import { PdfViewerBase } from '../index';
import { createElement, isNullOrUndefined, isBlazor, SanitizeHtmlHelper, Browser } from '@syncfusion/ej2-base';
import { Dialog } from '@syncfusion/ej2-popups';
import { splitArrayCollection, processPathData, getPathString } from '@syncfusion/ej2-drawings';
import { TextBox } from '@syncfusion/ej2-inputs';
import { cloneObject } from '../drawing/drawing-util';
import { CheckBox } from '@syncfusion/ej2-buttons';
import { Tab } from '@syncfusion/ej2-navigations';
import { Button } from '@syncfusion/ej2-buttons';
import { DisplayMode } from './types';
/* eslint-disable valid-jsdoc */
/**
 *
 * @param {Event} e - The event object.
 * @param {any} args - Additional arguments passed to the event handler.
 * @hidden
 * @returns {void}
 */
export class Signature {
    /**
     * Initialize the constructor of blazorUIadapater.
     *
     * @private
     * @param { PdfViewer } pdfViewer - Specified PdfViewer class.
     * @param { PdfViewerBase } pdfViewerBase - The pdfViewerBase.
     */
    constructor(pdfViewer, pdfViewerBase) {
        this.mouseMoving = true;
        this.canvasTouched = false;
        this.imageSignatureDataUrl = '';
        this.drawSignatureDataUrl = '';
        this.newObject = [];
        /**
         * @private
         */
        this.outputString = '';
        /**
         * @private
         */
        this.drawOutputString = '';
        /**
         * @private
         */
        this.imageOutputString = '';
        /**
         * @private
         */
        this.signaturecollection = [];
        /**
         * @private
         */
        this.outputcollection = [];
        /**
         * @private
         */
        this.signAnnotationIndex = [];
        this.fontsign = [];
        this.signfontStyle = [];
        this.isSaveSignature = false;
        this.isSaveInitial = false;
        this.isInitialFiledSaveSignature = false;
        this.isSignatureFieldsSaveSignature = false;
        this.issaveTypeSignature = false;
        this.issaveImageSignature = false;
        this.issaveTypeInitial = false;
        this.issaveImageInitial = false;
        this.saveSignatureTypeString = '';
        this.saveInitialTypeString = '';
        this.saveTypeString = '';
        this.signatureTypeString = '';
        this.initialTypeString = '';
        this.saveUploadString = '';
        this.saveSignatureUploadString = '';
        this.saveInitialUploadString = '';
        this.signatureUploadString = '';
        this.initialUploadString = '';
        this.clearUploadString = false;
        this.textValue = '';
        this.signatureDrawString = '';
        this.initialDrawString = '';
        this.signatureTextContentTop = 0.2;
        this.signatureTextContentLeft = 0.7;
        this.saveSignatureString = '';
        this.saveInitialString = '';
        /**
         * @private
         */
        this.saveImageString = '';
        this.signatureFieldCollection = [];
        this.signatureImageString = '';
        this.initialImageString = '';
        /**
         * @private
         */
        this.maxSaveLimit = 5;
        this.select = function (e) {
            if (this.canvasTouched) {
                this.mouseMoving = true;
                this.canvasTouched = false;
            }
            if (e.isSwiped && this.signaturetype === 'Draw' && this.mouseMoving) {
                e.cancel = true;
                this.mouseMoving = false;
            }
        };
        this.addStampImage = (args) => {
            // eslint-disable-next-line
            const proxy = this;
            const upoadedFiles = args.target.files;
            if (args.target.files[0] !== null) {
                const uploadedFile = upoadedFiles[0];
                if (uploadedFile.type.split('/')[0] === 'image') {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const canvas = document.getElementById(this.pdfViewer.element.id + '_signatureuploadCanvas_');
                        const context = canvas.getContext('2d');
                        const image = new Image();
                        // eslint-disable-next-line
                        const proxy = this;
                        image.onload = () => {
                            const signbutton = document.getElementById(this.pdfViewer.element.id + '_e-pv-upload-button');
                            signbutton.style.visibility = 'hidden';
                            context.drawImage(image, 0, 0, canvas.width, canvas.height);
                            proxy.enableCreateButton(false);
                            proxy.outputString = image.src;
                            proxy.signatureImageHeight = image.naturalHeight;
                            proxy.signatureImageWidth = image.naturalWidth;
                        };
                        image.src = e.currentTarget.result;
                        proxy.outputString = e.currentTarget.result;
                        proxy.switchTabImageSignature = e.currentTarget.result;
                    };
                    reader.readAsDataURL(uploadedFile);
                }
            }
            args.target.value = '';
            args.currentTarget.value = '';
        };
        this.pdfViewer = pdfViewer;
        this.pdfViewerBase = pdfViewerBase;
    }
    /**
     * @private
     * @returns {void}
     */
    createSignaturePanel() {
        const maximumWidth = 750;
        this.imageSignatureDataUrl = '';
        this.drawSignatureDataUrl = '';
        if (!isBlazor()) {
            const elementID = this.pdfViewer.element.id;
            const dialogDiv = createElement('div', { id: elementID + '_signature_window', className: 'e-pv-signature-window' });
            dialogDiv.style.display = 'block';
            this.pdfViewerBase.pageContainer.appendChild(dialogDiv);
            const appearanceTab = this.createSignatureCanvas();
            let signaturePanelHeader;
            if (!this.pdfViewerBase.isToolbarSignClicked) {
                if (this.pdfViewerBase.isInitialField) {
                    signaturePanelHeader = this.pdfViewer.localeObj.getConstant('HandwrittenInitialDialogHeaderText');
                }
                else {
                    signaturePanelHeader = this.pdfViewer.localeObj.getConstant('HandwrittenSignatureDialogHeaderText');
                }
            }
            else {
                if (this.pdfViewerBase.isInitialField) {
                    signaturePanelHeader = this.pdfViewer.localeObj.getConstant('InitialFieldDialogHeaderText');
                }
                else {
                    signaturePanelHeader = this.pdfViewer.localeObj.getConstant('SignatureFieldDialogHeaderText');
                }
            }
            if (this.signatureDialog) {
                this.signatureDialog.content = appearanceTab;
            }
            else {
                this.signatureDialog = new Dialog({
                    showCloseIcon: true, closeOnEscape: false, isModal: true, header: signaturePanelHeader, cssClass: 'e-pv-signature-dialog-height',
                    target: this.pdfViewerBase.mainContainer, content: appearanceTab, width: '750px', visible: true, allowDragging: true,
                    beforeClose: () => {
                        this.clearSignatureCanvas();
                        this.signatureDialog.destroy();
                        this.signatureDialog = null;
                        if (this.tabObj) {
                            this.tabObj.destroy();
                        }
                        const signatureWindow = document.getElementById(this.pdfViewer.element.id + '_signature_window');
                        if (signatureWindow) {
                            if (signatureWindow.parentNode) {
                                signatureWindow.parentNode.removeChild(signatureWindow);
                            }
                            else {
                                signatureWindow.parentElement.removeChild(signatureWindow);
                            }
                        }
                        if (!this.pdfViewerBase.isToolbarSignClicked && !this.pdfViewerBase.drawSignatureWithTool &&
                            this.pdfViewer.formFieldsModule && !isNullOrUndefined(this.pdfViewer.formFieldsModule.currentTarget)) {
                            this.pdfViewer.fireFocusOutFormField(this.pdfViewer.formFieldsModule.currentTarget.name, '');
                        }
                        this.pdfViewerBase.isToolbarSignClicked = false;
                        this.setFocus();
                    }
                });
                this.signatureDialog.buttons = [
                    { buttonModel: { content: this.pdfViewer.localeObj.getConstant('Clear'), disabled: true, cssClass: 'e-pv-clearbtn' }, click: this.clearSignatureCanvas.bind(this) },
                    { buttonModel: { content: this.pdfViewer.localeObj.getConstant('Cancel'), cssClass: 'e-pv-cancelbtn' }, click: this.closeSignaturePanel.bind(this) },
                    { buttonModel: { content: this.pdfViewer.localeObj.getConstant('Create'), isPrimary: true, disabled: true, cssClass: 'e-pv-createbtn' }, click: this.addSignatureInPage.bind(this) }
                ];
                this.signatureDialog.appendTo(dialogDiv);
            }
            if (this.pdfViewer.element.offsetWidth < maximumWidth) {
                this.updateCanvasSize();
            }
            if (this.pdfViewer.enableRtl) {
                this.signatureDialog.enableRtl = this.pdfViewer.enableRtl;
            }
            const checkboxItem = this.signatureDialog.content.ej2_instances[0].items[0];
            if (checkboxItem.header.label === 'DRAW') {
                const drawCheckbox = document.getElementById('checkbox');
                this.hideSignatureCheckbox(drawCheckbox);
            }
            else if (checkboxItem.header.label === 'TYPE') {
                const typeCheckbox = document.getElementById('checkbox1');
                this.hideSignatureCheckbox(typeCheckbox);
            }
            else {
                const imageCheckbox = document.getElementById('checkbox2');
                this.hideSignatureCheckbox(imageCheckbox);
            }
            this.setSignatureCanvasWidth();
        }
        else {
            const canvas = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
            if (canvas) {
                if (!this.pdfViewerBase.pageContainer.querySelector('.e-pv-signature-window')) {
                    const elementID = this.pdfViewer.element.id;
                    const dialogDiv = createElement('div', { id: elementID + '_signature_window', className: 'e-pv-signature-window' });
                    dialogDiv.style.display = 'block';
                    this.pdfViewerBase.pageContainer.appendChild(dialogDiv);
                }
                canvas.addEventListener('mousedown', this.signaturePanelMouseDown.bind(this));
                canvas.addEventListener('mousemove', this.signaturePanelMouseMove.bind(this));
                canvas.addEventListener('mouseup', this.signaturePanelMouseUp.bind(this));
                canvas.addEventListener('mouseleave', this.signaturePanelMouseUp.bind(this));
                canvas.addEventListener('touchstart', this.signaturePanelMouseDown.bind(this));
                canvas.addEventListener('touchmove', this.signaturePanelMouseMove.bind(this));
                canvas.addEventListener('touchend', this.signaturePanelMouseUp.bind(this));
                this.clearSignatureCanvas();
            }
            this.pdfViewer._dotnetInstance.invokeMethodAsync('OpenSignaturePanel', this.pdfViewerBase.isToolbarSignClicked);
        }
        this.drawSavedSignature();
    }
    setSignatureCanvasWidth() {
        const appearanceElement = document.getElementById(this.pdfViewer.element.id + 'Signature_appearance');
        if (appearanceElement) {
            const apperanceTabWidth = appearanceElement.clientWidth;
            const pathcanvas = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
            if (pathcanvas) {
                pathcanvas.width = apperanceTabWidth;
                pathcanvas.style.width = apperanceTabWidth + 'px';
            }
            const uploadCanvas = document.getElementById(this.pdfViewer.element.id + '_signatureuploadCanvas_');
            if (uploadCanvas) {
                uploadCanvas.width = apperanceTabWidth;
                uploadCanvas.style.width = apperanceTabWidth + 'px';
            }
            const textDiv = document.getElementById(this.pdfViewer.element.id + '_font_appearance');
            if (textDiv) {
                textDiv.width = apperanceTabWidth;
                textDiv.style.width = apperanceTabWidth + 'px';
            }
        }
    }
    drawSavedSignature() {
        if (!this.pdfViewerBase.isToolbarSignClicked && (this.isSaveSignature || this.isSaveInitial)) {
            if (!this.pdfViewerBase.isInitialField && this.isSaveSignature) {
                this.outputString = this.saveSignatureString;
            }
            else if (this.pdfViewerBase.isInitialField && this.isSaveInitial) {
                this.outputString = this.saveInitialString;
            }
            const canvas = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
            const context = canvas.getContext('2d');
            const image = new Image();
            image.onload = () => {
                context.drawImage(image, 0, 0);
            };
            if (!this.pdfViewerBase.isInitialField && this.isSaveSignature) {
                image.src = this.signatureDrawString;
            }
            else if (this.pdfViewerBase.isInitialField && this.isSaveInitial) {
                image.src = this.initialDrawString;
            }
            const checkbox = document.getElementById(this.pdfViewer.element.id + '_signatureCheckBox');
            if (checkbox) {
                checkbox.checked = true;
            }
            this.enableCreateButton(false);
            this.enableClearbutton(false);
        }
    }
    drawSavedTypeSignature() {
        let output = '';
        if (!this.pdfViewerBase.isToolbarSignClicked && (this.issaveTypeSignature || this.issaveTypeInitial)) {
            if (!this.pdfViewerBase.isInitialField && this.issaveTypeSignature) {
                output = this.saveSignatureTypeString;
            }
            else {
                output = this.saveInitialTypeString;
            }
        }
        return output;
    }
    drawSavedImageSignature() {
        let output = '';
        if (!this.pdfViewerBase.isToolbarSignClicked && (this.issaveImageSignature || this.issaveImageInitial)) {
            if (!this.pdfViewerBase.isInitialField && this.issaveImageSignature) {
                output = this.saveSignatureUploadString;
            }
            else {
                output = this.saveInitialUploadString;
            }
        }
        return output;
    }
    hideSignatureCheckbox(checkbox) {
        if (this.pdfViewerBase.isToolbarSignClicked) {
            if (this.pdfViewerBase.isInitialField) {
                if (this.pdfViewer.handWrittenSignatureSettings.initialDialogSettings &&
                    this.pdfViewer.handWrittenSignatureSettings.initialDialogSettings.hideSaveSignature) {
                    this.hideCheckboxParent(checkbox);
                }
            }
            else if (this.pdfViewer.handWrittenSignatureSettings.signatureDialogSettings &&
                this.pdfViewer.handWrittenSignatureSettings.signatureDialogSettings.hideSaveSignature) {
                this.hideCheckboxParent(checkbox);
            }
        }
        else {
            if (this.pdfViewerBase.isInitialField) {
                if (this.pdfViewer.initialFieldSettings.initialDialogSettings &&
                    this.pdfViewer.initialFieldSettings.initialDialogSettings.hideSaveSignature) {
                    this.hideCheckboxParent(checkbox);
                }
            }
            else {
                if (this.pdfViewer.signatureFieldSettings.signatureDialogSettings &&
                    this.pdfViewer.signatureFieldSettings.signatureDialogSettings.hideSaveSignature) {
                    this.hideCheckboxParent(checkbox);
                }
            }
        }
    }
    saveSignatureCheckbox() {
        if (this.pdfViewerBase.isToolbarSignClicked) {
            return false;
        }
        else {
            if (this.pdfViewerBase.isInitialField) {
                if (this.pdfViewer.initialFieldSettings.initialDialogSettings &&
                    this.pdfViewer.initialFieldSettings.initialDialogSettings.hideSaveSignature) {
                    return false;
                }
                else {
                    return this.isInitialFiledSaveSignature;
                }
            }
            else {
                if (this.pdfViewer.signatureFieldSettings.signatureDialogSettings &&
                    this.pdfViewer.signatureFieldSettings.signatureDialogSettings.hideSaveSignature) {
                    return false;
                }
                else {
                    return this.isSignatureFieldsSaveSignature;
                }
            }
        }
    }
    hideCheckboxParent(checkbox) {
        if (checkbox) {
            checkbox.parentElement.style.display = 'none';
        }
    }
    saveSignatureImage() {
        const checkbox = document.getElementById(this.pdfViewer.element.id + '_signatureCheckBox');
        if (checkbox && checkbox.checked) {
            if (this.outputString !== '') {
                if (!this.pdfViewerBase.isInitialField) {
                    this.isSaveSignature = true;
                    this.saveSignatureString = this.outputString;
                }
                else {
                    this.isSaveInitial = true;
                    this.saveInitialString = this.outputString;
                }
                const canvas = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
                this.saveImageString = canvas.toDataURL();
                if (!this.pdfViewerBase.isInitialField) {
                    this.signatureImageString = this.saveImageString;
                }
                else {
                    this.initialImageString = this.saveImageString;
                }
            }
        }
        else {
            if (this.isSaveSignature && !this.pdfViewerBase.isInitialField) {
                this.isSaveSignature = false;
                this.saveSignatureString = '';
                this.saveImageString = '';
                this.signatureImageString = '';
            }
            else if (this.isSaveInitial && this.pdfViewerBase.isInitialField) {
                this.isSaveInitial = false;
                this.saveInitialString = '';
                this.saveImageString = '';
                this.initialImageString = '';
            }
            this.clearSignatureCanvas();
        }
    }
    /**
     * @param {any} type - It describes about the type
     * @private
     * @returns {void}
     */
    addSignature(type) {
        let annot;
        if (this.pdfViewerBase.isToolbarSignClicked) {
            const annotationName = this.pdfViewer.annotation.createGUID();
            this.pdfViewerBase.currentSignatureAnnot = null;
            this.pdfViewerBase.isSignatureAdded = true;
            const pageIndex = this.pdfViewerBase.currentPageNumber - 1;
            const thickness = this.pdfViewer.handWrittenSignatureSettings.thickness ?
                this.pdfViewer.handWrittenSignatureSettings.thickness : 1;
            const opacity = this.pdfViewer.handWrittenSignatureSettings.opacity ?
                this.pdfViewer.handWrittenSignatureSettings.opacity : 1;
            const strokeColor = this.pdfViewer.handWrittenSignatureSettings.strokeColor ? this.pdfViewer.handWrittenSignatureSettings.strokeColor : '#000000';
            const fontSize = 16;
            const fontFamily = 'Helvetica';
            const signatureBounds = this.updateSignatureAspectRatio(this.outputString, true);
            const canvas = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
            this.saveImageString = canvas.toDataURL();
            if (!this.pdfViewerBase.isInitialField) {
                this.signatureImageString = this.saveImageString;
            }
            else {
                this.initialImageString = this.saveImageString;
            }
            annot = {
                id: 'sign' + this.pdfViewerBase.signatureCount, bounds: signatureBounds, pageIndex: pageIndex, data: this.outputString, fontFamily: fontFamily, fontSize: fontSize,
                shapeAnnotationType: 'HandWrittenSignature', opacity: opacity, strokeColor: strokeColor, thickness: thickness, signatureName: annotationName
            };
            this.pdfViewerBase.currentSignatureAnnot = annot;
            let checkbox;
            if (isBlazor()) {
                checkbox = document.getElementById(this.pdfViewer.element.id + '_signatureCheckBox');
            }
            else {
                checkbox = document.getElementById('checkbox');
            }
            if (checkbox && checkbox.checked) {
                this.addSignatureCollection();
            }
            this.hideSignaturePanel();
            this.pdfViewerBase.isToolbarSignClicked = false;
        }
        else {
            const checkbox = document.getElementById('checkbox');
            const typeCheckbox = document.getElementById('checkbox1');
            const imageCheckbox = document.getElementById('checkbox2');
            let isSignatureAdded = false;
            if (!isSignatureAdded) {
                const canvas = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
                this.saveImageString = canvas.toDataURL();
                if (checkbox) {
                    if (checkbox.checked) {
                        if (!this.pdfViewerBase.isInitialField) {
                            this.isSaveSignature = true;
                            this.signatureDrawString = this.saveImageString;
                            this.saveSignatureString = this.outputString;
                        }
                        else {
                            this.isSaveInitial = true;
                            this.initialDrawString = this.saveImageString;
                            this.saveInitialString = this.outputString;
                        }
                        this.checkSaveFiledSign(this.pdfViewerBase.isInitialField, true);
                    }
                    else {
                        if (!this.pdfViewerBase.isInitialField) {
                            this.isSaveSignature = false;
                            this.saveSignatureString = '';
                        }
                        else {
                            this.isSaveInitial = false;
                            this.saveInitialString = '';
                        }
                        this.checkSaveFiledSign(this.pdfViewerBase.isInitialField, false);
                    }
                }
                this.saveTypeSignature(typeCheckbox);
                this.saveUploadSignature(imageCheckbox);
                if (!this.pdfViewerBase.isInitialField) {
                    this.signatureImageString = this.saveImageString;
                }
                else {
                    this.initialImageString = this.saveImageString;
                }
                if (this.pdfViewer.formFieldsModule) {
                    this.pdfViewer.formFieldsModule.drawSignature(null, null, this.pdfViewerBase.currentTarget, null);
                }
                isSignatureAdded = true;
            }
        }
    }
    /**
     * @param {any} data - It describes about the data
     * @param {boolean} isSignature - It describes about the whether the isSignature is true or not
     * @param {any} currentField - It describes about the current field
     * @param {any} currentData - It describes about the current data
     * @private
     * @returns {any} - any
     */
    updateSignatureAspectRatio(data, isSignature, currentField, currentData) {
        const collectionData = processPathData(data);
        const csData = splitArrayCollection(collectionData);
        let minimumX = -1;
        let minimumY = -1;
        let maximumX = -1;
        let maximumY = -1;
        const signatureCanvas = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
        let signatureCavasWidth = 0;
        let signatureCavasHeight = 0;
        for (let m = 0; m < csData.length; m++) {
            const val = csData[parseInt(m.toString(), 10)];
            if (minimumX === -1) {
                minimumX = parseFloat(val['x'].toString());
                maximumX = parseFloat(val['x'].toString());
                minimumY = parseFloat(val['y'].toString());
                maximumY = parseFloat(val['y'].toString());
            }
            else {
                const point1 = parseFloat(val['x'].toString());
                const point2 = parseFloat(val['y'].toString());
                if (minimumX >= point1) {
                    minimumX = point1;
                }
                if (minimumY >= point2) {
                    minimumY = point2;
                }
                if (maximumX <= point1) {
                    maximumX = point1;
                }
                if (maximumY <= point2) {
                    maximumY = point2;
                }
            }
        }
        signatureCavasWidth = signatureCanvas ? signatureCanvas.clientWidth : 650;
        signatureCavasHeight = signatureCanvas ? signatureCanvas.clientHeight : 300;
        const newdifferenceX = maximumX - minimumX;
        const newdifferenceY = maximumY - minimumY;
        const signBounds = this.calculateSignatureBounds(signatureCavasWidth, signatureCavasHeight, newdifferenceX, newdifferenceY, isSignature, currentField, currentData);
        if (isSignature) {
            const zoomvalue = this.pdfViewerBase.getZoomFactor();
            const pageIndex = this.pdfViewerBase.currentPageNumber - 1;
            const pageDiv = document.getElementById(this.pdfViewer.element.id + '_pageDiv_' + pageIndex);
            const currentLeft = ((parseFloat(pageDiv.style.width) / 2) - (signBounds.currentWidth / 2)) / zoomvalue;
            const currentTop = ((parseFloat(pageDiv.style.height) / 2) - (signBounds.currentHeight / 2)) / zoomvalue;
            return { x: currentLeft, y: currentTop, width: signBounds.currentWidth, height: signBounds.currentHeight };
        }
        else {
            return { left: signBounds.currentLeftDiff, top: signBounds.currentTopDiff, width: signBounds.currentWidth,
                height: signBounds.currentHeight };
        }
    }
    calculateSignatureBounds(signatureCavasWidth, signatureCavasHeight, newdifferenceX, newdifferenceY, isSignature, currentField, currentData) {
        const ratioX = newdifferenceX / signatureCavasWidth;
        const ratioY = newdifferenceY / signatureCavasHeight;
        const zoomvalue = this.pdfViewerBase.getZoomFactor();
        let currentWidth = 0;
        let currentHeight = 0;
        let isSignatureStretched = false;
        let isHeightStretched = false;
        let leftDifference = 0;
        let topDifference = 0;
        if (isSignature) {
            currentWidth = this.pdfViewer.handWrittenSignatureSettings.width ? this.pdfViewer.handWrittenSignatureSettings.width : 150;
            currentHeight = this.pdfViewer.handWrittenSignatureSettings.height ? this.pdfViewer.handWrittenSignatureSettings.height : 100;
        }
        else {
            const fieldWidth = currentField ? currentField.style.width === '100%' ? currentField.clientWidth : parseFloat(currentField.style.width) : this.ConvertPointToPixel(currentData.LineBounds.Width);
            const fieldHeight = currentField ? currentField.style.height === '100%' ? currentField.clientHeight : parseFloat(currentField.style.height) : this.ConvertPointToPixel(currentData.LineBounds.Height);
            const fieldWidthRatio = fieldWidth / fieldHeight;
            const fieldHeightRatio = fieldHeight / fieldWidth;
            const canvasWidthRatio = signatureCavasWidth / signatureCavasHeight;
            const canvasHeightRatio = signatureCavasHeight / signatureCavasWidth;
            const fieldRotation = currentField ? currentField.offsetParent.offsetParent.style.transform ?
                currentField.offsetParent.offsetParent.style.transform : currentField.style.transform : currentData.RotationAngle;
            if ((fieldWidthRatio > canvasWidthRatio) || (fieldHeightRatio > canvasWidthRatio) ||
                ((Math.abs(fieldWidthRatio - fieldHeightRatio)) <= 1)) {
                let ratioDifference = 0;
                if ((fieldHeightRatio > canvasWidthRatio) || ((Math.abs(fieldWidthRatio - fieldHeightRatio)) <= 1)) {
                    isHeightStretched = true;
                    ratioDifference = fieldHeightRatio / canvasHeightRatio;
                }
                else {
                    isSignatureStretched = true;
                    ratioDifference = fieldWidthRatio / canvasWidthRatio;
                }
                if (fieldRotation === 'rotate(90deg)' || fieldRotation === 'rotate(270deg)') {
                    currentWidth = fieldHeight / zoomvalue;
                    currentHeight = fieldWidth / zoomvalue;
                }
                else {
                    if (isSignatureStretched) {
                        leftDifference = fieldWidth / zoomvalue;
                        currentWidth = (fieldWidth / ratioDifference) / zoomvalue;
                        currentHeight = fieldHeight / zoomvalue;
                    }
                    if (isHeightStretched) {
                        topDifference = fieldHeight / zoomvalue;
                        currentWidth = fieldWidth / zoomvalue;
                        currentHeight = (fieldHeight / ratioDifference) / zoomvalue;
                    }
                }
            }
            else {
                if (fieldRotation === 'rotate(90deg)' || fieldRotation === 'rotate(270deg)') {
                    currentWidth = fieldHeight / zoomvalue;
                    currentHeight = fieldWidth / zoomvalue;
                }
                else {
                    currentWidth = fieldWidth / zoomvalue;
                    currentHeight = fieldHeight / zoomvalue;
                }
            }
        }
        let currentLeftDiff = (signatureCavasWidth - newdifferenceX) / 2;
        let currentTopDiff = (signatureCavasHeight - newdifferenceY) / 2;
        if (isSignatureStretched) {
            currentLeftDiff = (currentLeftDiff / signatureCavasWidth) * leftDifference;
            const leftValueDiff = ((leftDifference * ratioX) - (currentWidth * ratioX)) / 2;
            currentLeftDiff = currentLeftDiff + leftValueDiff;
            currentTopDiff = (currentTopDiff / signatureCavasHeight) * currentHeight;
        }
        else if (isHeightStretched) {
            currentLeftDiff = (currentLeftDiff / signatureCavasWidth) * currentWidth;
            currentTopDiff = (currentTopDiff / signatureCavasHeight) * topDifference;
            const topValueDiff = ((topDifference * ratioY) - (currentHeight * ratioY)) / 2;
            currentTopDiff = currentTopDiff + topValueDiff;
        }
        else {
            currentLeftDiff = (currentLeftDiff / signatureCavasWidth) * currentWidth;
            currentTopDiff = (currentTopDiff / signatureCavasHeight) * currentHeight;
        }
        if (this.pdfViewer.signatureFitMode !== 'Stretch') {
            currentWidth = currentWidth * ratioX;
            currentHeight = currentHeight * ratioY;
        }
        return { currentLeftDiff: currentLeftDiff, currentTopDiff: currentTopDiff, currentWidth: currentWidth,
            currentHeight: currentHeight };
    }
    /**
     * @param {string} id - It describes about the id value
     * @private
     * @returns {void}
     */
    setFocus(id) {
        if (!id) {
            if (this.currentTarget) {
                document.getElementById(this.currentTarget.id).focus();
            }
        }
        else {
            this.removeFocus();
            const signatureElement = document.getElementById(id);
            signatureElement.classList.add('e-pv-signature-focus');
        }
    }
    /**
     * @private
     * @returns {void}
     */
    removeFocus() {
        if (this.signatureFieldCollection) {
            let signatureFields = this.signatureFieldCollection;
            if (signatureFields.length === 0) {
                signatureFields = this.getSignField();
            }
            for (let i = 0; i < this.signatureFieldCollection.length; i++) {
                const signatureFieldId = this.pdfViewer.formDesignerModule ?
                    this.signatureFieldCollection[parseInt(i.toString(), 10)].FormField.uniqueID :
                    this.signatureFieldCollection[parseInt(i.toString(), 10)].uniqueID;
                const signatureElement = document.getElementById(signatureFieldId);
                if (signatureElement) {
                    signatureElement.classList.remove('e-pv-signature-focus');
                }
            }
            if (this.pdfViewer.formFieldsModule.currentTarget) {
                this.pdfViewer.formFieldsModule.currentTarget.classList.remove('e-pv-signature-focus');
            }
        }
    }
    getSignField() {
        if (this.pdfViewer.formDesignerModule) {
            this.signatureFieldCollection =
                this.pdfViewer.formDesignerModule.getFormDesignerSignField(this.signatureFieldCollection);
        }
        else {
            this.signatureFieldCollection = this.getFormFieldSignField();
        }
        return this.signatureFieldCollection;
    }
    getFormFieldSignField() {
        const data = this.pdfViewerBase.getItemFromSessionStorage('_formfields');
        let currentData;
        if (data) {
            const formFieldsData = JSON.parse(data);
            for (let i = 0; i < formFieldsData.length; i++) {
                currentData = formFieldsData[parseInt(i.toString(), 10)];
                if (currentData.Name === 'SignatureField' || currentData.Name === 'InitialField') {
                    currentData['uniqueID'] = this.pdfViewer.element.id + 'input_' + currentData.PageIndex + '_' + i;
                    this.signatureFieldCollection.push(formFieldsData[parseInt(i.toString(), 10)]);
                }
            }
        }
        return this.signatureFieldCollection;
    }
    checkSaveFiledSign(initialField, saveSign) {
        if (initialField) {
            this.isInitialFiledSaveSignature = saveSign;
        }
        else {
            this.isSignatureFieldsSaveSignature = saveSign;
        }
    }
    addSignatureInPage() {
        if (this.signaturetype === 'Draw') {
            this.addSignature();
        }
        else if (this.signaturetype === 'Type') {
            this.typeAddSignature();
        }
        else {
            this.imageAddSignature();
        }
        this.drawOutputString = '';
        this.imageOutputString = '';
    }
    typeAddSignature(type) {
        if (this.pdfViewerBase.isToolbarSignClicked) {
            const zoomvalue = this.pdfViewerBase.getZoomFactor();
            let annot = null;
            const annotationName = this.pdfViewer.annotation.createGUID();
            this.pdfViewerBase.currentSignatureAnnot = null;
            this.pdfViewerBase.isSignatureAdded = true;
            const pageIndex = this.pdfViewerBase.currentPageNumber - 1;
            const pageDiv = document.getElementById(this.pdfViewer.element.id + '_pageDiv_' + pageIndex);
            const thickness = this.pdfViewer.handWrittenSignatureSettings.thickness ?
                this.pdfViewer.handWrittenSignatureSettings.thickness : 1;
            const opacity = this.pdfViewer.handWrittenSignatureSettings.opacity ?
                this.pdfViewer.handWrittenSignatureSettings.opacity : 1;
            const strokeColor = this.pdfViewer.handWrittenSignatureSettings.strokeColor ? this.pdfViewer.handWrittenSignatureSettings.strokeColor : '#000000';
            const fontSize = 16;
            let currentLeft = 0;
            let currentTop = 0;
            let currentHeight = 65;
            let currentWidth = 200;
            if (!isNullOrUndefined(this.pdfViewer.handWrittenSignatureSettings.height) && (this.pdfViewer.signatureFitMode === 'Stretch')) {
                currentHeight = this.pdfViewer.handWrittenSignatureSettings.height;
            }
            if (!isNullOrUndefined(this.pdfViewer.handWrittenSignatureSettings.width) && (this.pdfViewer.signatureFitMode === 'Stretch')) {
                currentWidth = this.pdfViewer.handWrittenSignatureSettings.width;
            }
            currentLeft = ((parseFloat(pageDiv.style.width) / 2) - (currentWidth / 2)) / zoomvalue;
            currentTop = ((parseFloat(pageDiv.style.height) / 2) - (currentHeight / 2)) / zoomvalue;
            const zoomFactor = this.pdfViewerBase.getZoomFactor();
            if (!this.signtypevalue) {
                this.updateSignatureTypeValue(true);
            }
            const inputValue = this.signtypevalue;
            if (this.pdfViewer.enableHtmlSanitizer && this.outputString) {
                this.outputString = SanitizeHtmlHelper.sanitize(this.outputString);
            }
            annot = {
                id: 'Typesign' + this.pdfViewerBase.signatureCount, bounds: {
                    left: currentLeft / zoomFactor, top: currentTop / zoomFactor, x: currentLeft / zoomFactor,
                    y: currentTop / zoomFactor, width: currentWidth, height: currentHeight
                }, pageIndex: pageIndex, dynamicText: inputValue, data: this.pdfViewerBase.signatureModule.outputString, shapeAnnotationType: 'SignatureText',
                opacity: opacity, strokeColor: strokeColor, thickness: thickness, fontSize: fontSize, fontFamily: this.fontName,
                signatureName: annotationName
            };
            this.pdfViewerBase.currentSignatureAnnot = annot;
            let checkbox;
            if (isBlazor()) {
                checkbox = document.getElementById(this.pdfViewer.element.id + '_signatureCheckBox');
            }
            else {
                checkbox = document.getElementById('checkbox1');
            }
            if (checkbox && checkbox.checked) {
                this.addSignatureCollection();
            }
            this.signtypevalue = '';
            this.hideSignaturePanel();
            this.pdfViewerBase.isToolbarSignClicked = false;
        }
        else {
            const checkbox = document.getElementById('checkbox');
            const typeCheckbox = document.getElementById('checkbox1');
            const imageCheckbox = document.getElementById('checkbox2');
            let isSignatureAdded = false;
            if (!isSignatureAdded) {
                this.saveDrawSignature(checkbox);
                this.saveUploadSignature(imageCheckbox);
                const canvas = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
                if (canvas) {
                    this.saveTypeString = canvas.toDataURL();
                }
                this.updateSignatureTypeValue();
                if (this.pdfViewer.enableHtmlSanitizer && this.textValue) {
                    this.textValue = SanitizeHtmlHelper.sanitize(this.textValue);
                }
                if (typeCheckbox && typeCheckbox.checked) {
                    if (!this.pdfViewerBase.isInitialField) {
                        this.isSaveSignature = true;
                        this.signatureImageString = this.saveTypeString;
                        this.saveSignatureTypeString = this.textValue;
                        this.issaveTypeSignature = true;
                    }
                    else {
                        this.isSaveInitial = true;
                        this.initialImageString = this.saveTypeString;
                        this.saveInitialTypeString = this.textValue;
                        this.issaveTypeInitial = true;
                    }
                }
                else {
                    if (!this.pdfViewerBase.isInitialField) {
                        this.isSaveSignature = false;
                        this.saveSignatureTypeString = '';
                        this.issaveTypeSignature = false;
                    }
                    else {
                        this.isSaveInitial = false;
                        this.saveInitialTypeString = '';
                        this.issaveTypeInitial = false;
                    }
                }
                if (!this.pdfViewerBase.isInitialField) {
                    this.signatureTypeString = this.saveTypeString;
                }
                else {
                    this.initialTypeString = this.saveTypeString;
                }
                if (this.pdfViewer.formFieldsModule) {
                    this.pdfViewer.formFieldsModule.drawSignature('Type', this.textValue, this.pdfViewerBase.currentTarget);
                }
                isSignatureAdded = true;
                this.hideSignaturePanel();
            }
        }
    }
    imageAddSignature(type) {
        if (this.pdfViewerBase.isToolbarSignClicked) {
            const zoomvalue = this.pdfViewerBase.getZoomFactor();
            let annot = null;
            const annotationName = this.pdfViewer.annotation.createGUID();
            this.pdfViewerBase.currentSignatureAnnot = null;
            this.pdfViewerBase.isSignatureAdded = true;
            const pageIndex = this.pdfViewerBase.currentPageNumber - 1;
            const pageDiv = document.getElementById(this.pdfViewer.element.id + '_pageDiv_' + pageIndex);
            const thickness = this.pdfViewer.handWrittenSignatureSettings.thickness ?
                this.pdfViewer.handWrittenSignatureSettings.thickness : 1;
            const opacity = this.pdfViewer.handWrittenSignatureSettings.opacity ?
                this.pdfViewer.handWrittenSignatureSettings.opacity : 1;
            const strokeColor = this.pdfViewer.handWrittenSignatureSettings.strokeColor ? this.pdfViewer.handWrittenSignatureSettings.strokeColor : '#000000';
            const fontSize = 16;
            let currentLeft = 0;
            let currentTop = 0;
            const standardImageRatio = 100;
            let currentHeight = 0;
            let currentWidth = 0;
            if (this.pdfViewer.enableHtmlSanitizer && this.outputString) {
                this.outputString = SanitizeHtmlHelper.sanitize(this.outputString);
            }
            if (!isNullOrUndefined(this.pdfViewer.handWrittenSignatureSettings.height) && (this.pdfViewer.signatureFitMode === 'Stretch')) {
                currentHeight = this.pdfViewer.handWrittenSignatureSettings.height;
            }
            else if (this.signatureImageHeight >= this.signatureImageWidth) {
                currentHeight = ((this.signatureImageHeight / this.signatureImageHeight) * standardImageRatio);
            }
            else {
                currentHeight = ((this.signatureImageHeight / this.signatureImageWidth) * standardImageRatio);
            }
            if (!isNullOrUndefined(this.pdfViewer.handWrittenSignatureSettings.width) && (this.pdfViewer.signatureFitMode === 'Stretch')) {
                currentWidth = this.pdfViewer.handWrittenSignatureSettings.width;
            }
            else if (this.signatureImageHeight >= this.signatureImageWidth) {
                currentWidth = ((this.signatureImageWidth / this.signatureImageHeight) * standardImageRatio);
            }
            else {
                currentWidth = ((this.signatureImageWidth / this.signatureImageWidth) * standardImageRatio);
            }
            currentLeft = ((parseFloat(pageDiv.style.width) / 2) - (currentWidth / 2)) / zoomvalue;
            currentTop = ((parseFloat(pageDiv.style.height) / 2) - (currentHeight / 2)) / zoomvalue;
            const zoomFactor = this.pdfViewerBase.getZoomFactor();
            const inputValue = this.signtypevalue;
            annot = {
                id: 'Typesign' + this.pdfViewerBase.signatureCount, bounds: {
                    left: currentLeft / zoomFactor, top: currentTop / zoomFactor, x: currentLeft / zoomFactor,
                    y: currentTop / zoomFactor, width: currentWidth, height: currentHeight
                }, pageIndex: pageIndex, dynamicText: inputValue, data: this.pdfViewerBase.signatureModule.outputString, shapeAnnotationType: 'SignatureImage',
                opacity: opacity, strokeColor: strokeColor, thickness: thickness, fontSize: fontSize, fontFamily: this.fontName,
                signatureName: annotationName
            };
            this.pdfViewerBase.currentSignatureAnnot = annot;
            let checkbox;
            if (isBlazor()) {
                checkbox = document.getElementById(this.pdfViewer.element.id + '_signatureCheckBox');
            }
            else {
                checkbox = document.getElementById('checkbox2');
            }
            if (checkbox && checkbox.checked) {
                this.addSignatureCollection();
            }
            this.hideSignaturePanel();
            this.pdfViewerBase.isToolbarSignClicked = false;
        }
        else {
            const checkbox = document.getElementById('checkbox');
            const typeCheckbox = document.getElementById('checkbox1');
            const imageCheckbox = document.getElementById('checkbox2');
            let isSignatureAdded = false;
            if (!isSignatureAdded) {
                this.saveDrawSignature(checkbox);
                this.saveTypeSignature(typeCheckbox);
                const canvas = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
                if (canvas) {
                    this.saveUploadString = canvas.toDataURL();
                }
                if (this.pdfViewer.enableHtmlSanitizer && this.outputString) {
                    this.outputString = SanitizeHtmlHelper.sanitize(this.outputString);
                }
                if (imageCheckbox && imageCheckbox.checked) {
                    if (!this.pdfViewerBase.isInitialField) {
                        this.isSaveSignature = true;
                        this.signatureImageString = this.saveUploadString;
                        this.saveSignatureUploadString = this.outputString;
                        this.issaveImageSignature = true;
                    }
                    else {
                        this.isSaveInitial = true;
                        this.initialImageString = this.saveUploadString;
                        this.saveInitialUploadString = this.outputString;
                        this.issaveImageInitial = true;
                    }
                }
                else {
                    if (!this.pdfViewerBase.isInitialField) {
                        this.isSaveSignature = false;
                        this.saveSignatureUploadString = '';
                        this.issaveImageSignature = false;
                    }
                    else {
                        this.isSaveInitial = false;
                        this.saveInitialUploadString = '';
                        this.issaveImageInitial = false;
                    }
                }
                if (!this.pdfViewerBase.isInitialField) {
                    this.signatureUploadString = this.saveUploadString;
                }
                else {
                    this.initialUploadString = this.saveUploadString;
                }
                if (this.pdfViewer.formFieldsModule) {
                    this.pdfViewer.formFieldsModule.drawSignature('Image', '', this.pdfViewerBase.currentTarget);
                }
                isSignatureAdded = true;
                this.hideSignaturePanel();
            }
        }
    }
    saveDrawSignature(checkbox) {
        if (checkbox) {
            if (checkbox.checked) {
                if (this.drawOutputString !== '') {
                    const canvas = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
                    this.saveImageString = canvas.toDataURL();
                    if (!this.pdfViewerBase.isInitialField) {
                        this.saveSignatureString = this.drawOutputString;
                        this.signatureDrawString = this.saveImageString;
                    }
                    else {
                        this.saveInitialString = this.drawOutputString;
                        this.initialDrawString = this.saveImageString;
                    }
                    this.checkSaveFiledSign(this.pdfViewerBase.isInitialField, true);
                }
            }
            else {
                if (!this.pdfViewerBase.isInitialField) {
                    this.saveSignatureString = '';
                }
                else {
                    this.saveInitialString = '';
                }
                this.checkSaveFiledSign(this.pdfViewerBase.isInitialField, false);
            }
        }
    }
    saveTypeSignature(typeCheckbox) {
        if (typeCheckbox) {
            if (typeCheckbox.checked) {
                this.updateSignatureTypeValue();
                if (this.textValue !== '') {
                    if (!this.pdfViewerBase.isInitialField) {
                        this.issaveTypeSignature = true;
                        this.saveSignatureTypeString = this.textValue;
                    }
                    else {
                        this.issaveTypeInitial = true;
                        this.saveInitialTypeString = this.textValue;
                    }
                }
            }
            else {
                if (!this.pdfViewerBase.isInitialField) {
                    this.saveSignatureTypeString = '';
                    this.issaveTypeSignature = false;
                }
                else {
                    this.saveInitialTypeString = '';
                    this.issaveTypeInitial = false;
                }
            }
        }
    }
    saveUploadSignature(imageCheckbox) {
        if (imageCheckbox) {
            if (imageCheckbox.checked) {
                const imageCanvas = document.getElementById(this.pdfViewer.element.id + '_signatureuploadCanvas_');
                const uploadString = imageCanvas.toDataURL();
                const imageString = document.getElementById(this.pdfViewer.element.id + '_e-pv-upload-button').style.visibility === 'hidden' ? uploadString : '';
                if (imageString !== '') {
                    if (!this.pdfViewerBase.isInitialField) {
                        this.issaveImageSignature = true;
                        this.saveSignatureUploadString = imageString;
                    }
                    else {
                        this.issaveImageInitial = true;
                        this.saveInitialUploadString = imageString;
                    }
                }
            }
            else {
                if (!this.pdfViewerBase.isInitialField) {
                    this.saveSignatureUploadString = '';
                    this.issaveImageSignature = false;
                }
                else {
                    this.saveInitialUploadString = '';
                    this.issaveImageInitial = false;
                }
            }
        }
    }
    updateSignatureTypeValue(isType) {
        const fontElements = document.querySelectorAll('.e-pv-font-sign');
        if (fontElements) {
            for (let j = 0; j < fontElements.length; j++) {
                if (fontElements[parseInt(j.toString(), 10)] && fontElements[parseInt(j.toString(), 10)].style.borderColor === 'red') {
                    if (this.pdfViewerBase.isToolbarSignClicked) {
                        if (isType) {
                            this.signtypevalue = fontElements[parseInt(j.toString(), 10)].textContent;
                            this.outputString = fontElements[parseInt(j.toString(), 10)].textContent;
                        }
                        else {
                            this.outputString = fontElements[parseInt(j.toString(), 10)].textContent;
                        }
                    }
                    else {
                        if (isType) {
                            this.signtypevalue = fontElements[parseInt(j.toString(), 10)].textContent;
                            this.textValue = fontElements[parseInt(j.toString(), 10)].textContent;
                        }
                        else {
                            this.textValue = fontElements[parseInt(j.toString(), 10)].textContent;
                        }
                    }
                    try {
                        this.fontName = JSON.parse(fontElements[parseInt(j.toString(), 10)].style.fontFamily);
                    }
                    catch (e) {
                        this.fontName = fontElements[parseInt(j.toString(), 10)].style.fontFamily;
                    }
                }
            }
        }
    }
    /**
     * @private
     * @returns {void}
     */
    hideSignaturePanel() {
        if (this.signatureDialog) {
            this.signatureDialog.hide();
        }
    }
    bindTypeSignatureClickEvent() {
        if (isBlazor()) {
            for (let i = 0; i < 4; i++) {
                const fontElement = document.querySelector('#' + this.pdfViewer.element.id + '_font_signature' + i);
                if (fontElement) {
                    fontElement.addEventListener('click', this.typeSignatureclicked.bind(this));
                }
            }
        }
    }
    bindDrawSignatureClickEvent() {
        const canvas = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
        if (canvas) {
            canvas.addEventListener('mousedown', this.signaturePanelMouseDown.bind(this));
            canvas.addEventListener('mousemove', this.signaturePanelMouseMove.bind(this));
            canvas.addEventListener('mouseup', this.signaturePanelMouseUp.bind(this));
            canvas.addEventListener('mouseleave', this.signaturePanelMouseUp.bind(this));
            canvas.addEventListener('touchstart', this.signaturePanelMouseDown.bind(this));
            canvas.addEventListener('touchmove', this.signaturePanelMouseMove.bind(this));
            canvas.addEventListener('touchend', this.signaturePanelMouseUp.bind(this));
        }
    }
    typeSignatureclicked(event) {
        const eventTarget = event.target;
        if (eventTarget) {
            for (let i = 0; i < 4; i++) {
                const fontElement = document.querySelector('#' + this.pdfViewer.element.id + '_font_signature' + i);
                if (fontElement) {
                    fontElement.style.borderColor = '';
                }
            }
            eventTarget.style.borderColor = 'red';
            this.outputString = eventTarget.textContent;
            try {
                this.fontName = JSON.parse(eventTarget.style.fontFamily);
            }
            catch (e) {
                this.fontName = eventTarget.style.fontFamily;
            }
            this.enableCreateButton(false);
        }
    }
    createSignatureCanvas() {
        const previousField = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
        const field = document.getElementById(this.pdfViewer.element.id + 'Signature_appearance');
        if (previousField) {
            previousField.remove();
        }
        if (field) {
            field.remove();
        }
        let canvasHeight = 305;
        const viewerHeight = this.pdfViewer.element.clientHeight;
        if (viewerHeight <= 500) {
            canvasHeight = 250;
        }
        else if (viewerHeight > 500 && viewerHeight <= 750) {
            canvasHeight = 275;
        }
        const appearanceDiv = createElement('div', { id: this.pdfViewer.element.id + 'Signature_appearance', className: 'e-pv-signature-apperance', styles: 'margin-top:30px' });
        const canvas = createElement('canvas', { id: this.pdfViewer.element.id + '_signatureCanvas_', className: 'e-pv-signature-canvas' });
        canvas.classList.add('e-pv-canvas-signature');
        canvas.height = canvasHeight;
        canvas.style.height = canvasHeight + 'px';
        canvas.style.border = '1px dotted #bdbdbd';
        canvas.style.backgroundColor = 'white';
        canvas.style.boxSizing = 'border-box';
        canvas.style.borderRadius = '2px';
        canvas.addEventListener('mousedown', this.signaturePanelMouseDown.bind(this));
        canvas.addEventListener('mousemove', this.signaturePanelMouseMove.bind(this));
        canvas.addEventListener('mouseup', this.signaturePanelMouseUp.bind(this));
        canvas.addEventListener('mouseleave', this.signaturePanelMouseLeave.bind(this));
        canvas.addEventListener('touchstart', this.signaturePanelMouseDown.bind(this));
        canvas.addEventListener('touchmove', this.signaturePanelMouseMove.bind(this));
        canvas.addEventListener('touchend', this.signaturePanelMouseUp.bind(this));
        appearanceDiv.appendChild(canvas);
        let checkBoxObj;
        let input;
        let saveCheckBoxContent;
        if (this.pdfViewerBase.isToolbarSignClicked && !this.pdfViewerBase.isInitialField) {
            saveCheckBoxContent = this.pdfViewer.localeObj.getConstant('Save Signature');
        }
        else {
            saveCheckBoxContent = this.pdfViewerBase.isInitialField ? this.pdfViewer.localeObj.getConstant('Save Initial') : this.pdfViewer.localeObj.getConstant('Save Signature');
        }
        if (!this.pdfViewer.hideSaveSignature) {
            input = document.createElement('input');
            input.type = 'checkbox';
            input.id = 'checkbox';
            appearanceDiv.appendChild(input);
            checkBoxObj = new CheckBox({ label: saveCheckBoxContent, disabled: false, checked: false });
            checkBoxObj.appendTo(input);
        }
        if (!this.pdfViewerBase.isInitialField) {
            this.isSaveSignature = this.saveSignatureCheckbox();
        }
        else {
            this.isSaveInitial = this.saveSignatureCheckbox();
        }
        if (this.isSaveSignature && !this.pdfViewerBase.isInitialField) {
            checkBoxObj.checked = true;
        }
        else if (this.isSaveInitial && this.pdfViewerBase.isInitialField) {
            checkBoxObj.checked = true;
        }
        //if (!this.pdfViewerBase.isToolbarSignClicked) {
        const typeDiv = createElement('div', { id: this.pdfViewer.element.id + 'type_appearance', className: 'e-pv-signature-apperance', styles: 'margin-top:6px' });
        const inputText = document.createElement('input');
        if (!this.pdfViewerBase.isInitialField && this.issaveTypeSignature && !this.pdfViewerBase.isToolbarSignClicked) {
            inputText.value = this.drawSavedTypeSignature();
        }
        else if (this.pdfViewerBase.isInitialField && this.issaveTypeInitial && !this.pdfViewerBase.isToolbarSignClicked) {
            inputText.value = this.drawSavedTypeSignature();
        }
        inputText.type = 'text';
        inputText.id = this.pdfViewer.element.id + '_e-pv-Signtext-box';
        typeDiv.appendChild(inputText);
        const inputobj = new TextBox({
            placeholder: this.pdfViewer.localeObj.getConstant('Enter Signature as Name'),
            floatLabelType: 'Auto'
        });
        inputobj.appendTo(inputText);
        const fontDiv = createElement('div', { id: this.pdfViewer.element.id + '_font_appearance', className: 'e-pv-font-appearance-style' });
        fontDiv.classList.add('e-pv-canvas-signature');
        fontDiv.style.height = (canvasHeight - 35) + 'px';
        fontDiv.style.border = '1px dotted #bdbdbd';
        fontDiv.style.boxSizing = 'border-box';
        fontDiv.style.borderRadius = '2px';
        fontDiv.style.backgroundColor = 'white';
        fontDiv.style.color = 'black';
        fontDiv.style.marginTop = '8px';
        fontDiv.style.paddingRight = '0px';
        typeDiv.appendChild(fontDiv);
        input = document.createElement('input');
        input.type = 'checkbox';
        input.id = 'checkbox1';
        typeDiv.appendChild(input);
        checkBoxObj = new CheckBox({ label: saveCheckBoxContent, disabled: false, checked: false });
        checkBoxObj.appendTo(input);
        if (this.issaveTypeSignature && !this.pdfViewerBase.isInitialField && !this.pdfViewerBase.isToolbarSignClicked) {
            checkBoxObj.checked = true;
        }
        else if (this.issaveTypeInitial && this.pdfViewerBase.isInitialField && !this.pdfViewerBase.isToolbarSignClicked) {
            checkBoxObj.checked = true;
        }
        inputobj.addEventListener('input', this.renderSignatureText.bind(this));
        this.enableCreateButton(true);
        const tab = createElement('div', { id: this.pdfViewer.element.id + 'Signature_tab' });
        const uploadDiv = createElement('div', { id: this.pdfViewer.element.id + 'upload_appearance', className: 'e-pv-signature-apperance', styles: 'padding-top:30px' });
        const button = document.createElement('div');
        button.id = this.pdfViewer.element.id + '_e-pv-upload-button';
        uploadDiv.appendChild(button);
        const uploadButton = new Button({ cssClass: 'e-pv-sign-upload', content: this.pdfViewer.localeObj.getConstant('Browse Signature Image') });
        uploadButton.appendTo(button);
        uploadButton.element.style.position = 'absolute';
        const uploadCanvas = createElement('canvas', { id: this.pdfViewer.element.id + '_signatureuploadCanvas_', className: 'e-pv-signature-uploadcanvas' });
        if (this.pdfViewer.element.offsetWidth > 750) {
            uploadCanvas.width = 714;
        }
        else {
            uploadCanvas.width = this.pdfViewer.element.offsetWidth - 35;
        }
        uploadCanvas.classList.add('e-pv-canvas-signature');
        uploadCanvas.height = canvasHeight;
        uploadCanvas.style.height = canvasHeight + 'px';
        uploadButton.element.style.left = ((uploadCanvas.width / 2) - 50) + 'px';
        uploadButton.element.style.top = ((parseFloat(uploadCanvas.style.height) / 2) + 20) + 'px';
        uploadCanvas.style.border = '1px dotted #bdbdbd';
        uploadCanvas.style.backgroundColor = 'transparent';
        uploadCanvas.style.boxSizing = 'border-box';
        uploadCanvas.style.borderRadius = '2px';
        uploadCanvas.style.zIndex = '0';
        let imageUploadString = '';
        if (!this.pdfViewerBase.isInitialField && this.issaveImageSignature && !this.pdfViewerBase.isToolbarSignClicked) {
            imageUploadString = this.drawSavedImageSignature();
        }
        else if (this.pdfViewerBase.isInitialField && this.issaveImageInitial && !this.pdfViewerBase.isToolbarSignClicked) {
            imageUploadString = this.drawSavedImageSignature();
        }
        if (imageUploadString !== '' && !this.pdfViewerBase.isToolbarSignClicked) {
            this.clearUploadString = false;
            const ctx = uploadCanvas.getContext('2d');
            const image = new Image();
            image.src = imageUploadString;
            image.onload = function () {
                ctx.drawImage(image, 0, 0, uploadCanvas.width, uploadCanvas.height);
            };
            uploadButton.element.style.display = 'hidden';
        }
        uploadDiv.appendChild(uploadCanvas);
        input = document.createElement('input');
        input.type = 'checkbox';
        input.id = 'checkbox2';
        uploadDiv.appendChild(input);
        checkBoxObj = new CheckBox({ label: saveCheckBoxContent, disabled: false, checked: false });
        checkBoxObj.appendTo(input);
        if (this.issaveImageSignature && !this.pdfViewerBase.isInitialField && !this.pdfViewerBase.isToolbarSignClicked) {
            checkBoxObj.checked = true;
        }
        else if (this.issaveImageInitial && this.pdfViewerBase.isInitialField && !this.pdfViewerBase.isToolbarSignClicked) {
            checkBoxObj.checked = true;
        }
        button.addEventListener('click', this.uploadSignatureImage.bind(this));
        this.signfontStyle = [{ FontName: 'Helvetica' }, { FontName: 'Times New Roman' }, { FontName: 'Courier' }, { FontName: 'Symbol' }];
        const fontSignature = [];
        if (this.pdfViewerBase.isToolbarSignClicked && !isNullOrUndefined(this.pdfViewer.handWrittenSignatureSettings.typeSignatureFonts)) {
            for (let j = 0; j < 4; j++) {
                if (!isNullOrUndefined(this.pdfViewer.handWrittenSignatureSettings.typeSignatureFonts[parseInt(j.toString(), 10)])) {
                    this.signfontStyle[parseInt(j.toString(), 10)].FontName =
                        this.pdfViewer.handWrittenSignatureSettings.typeSignatureFonts[parseInt(j.toString(), 10)];
                }
            }
        }
        this.setCustomFonts();
        for (let i = 0; i < this.signfontStyle.length; i++) {
            fontSignature[parseInt(i.toString(), 10)] = document.createElement('div');
            fontSignature[parseInt(i.toString(), 10)].id = '_font_signature' + i + '';
            fontSignature[parseInt(i.toString(), 10)].classList.add('e-pv-font-sign');
            if (canvasHeight === 275) {
                fontSignature[parseInt(i.toString(), 10)].style.fontSize = '13px';
                fontSignature[parseInt(i.toString(), 10)].style.paddingTop = '30px';
                fontSignature[parseInt(i.toString(), 10)].style.height = '78px';
            }
            else if (canvasHeight === 250) {
                fontSignature[parseInt(i.toString(), 10)].style.fontSize = '12px';
                fontSignature[parseInt(i.toString(), 10)].style.paddingTop = '25px';
                fontSignature[parseInt(i.toString(), 10)].style.height = '68px';
            }
        }
        this.fontsign = fontSignature;
        // eslint-disable-next-line
        const proxy = this;
        let items = [];
        if (this.pdfViewerBase.isToolbarSignClicked) {
            if (this.pdfViewerBase.isInitialField) {
                items = this.showHideSignatureTab((this.pdfViewer.handWrittenSignatureSettings.initialDialogSettings ?
                    this.pdfViewer.handWrittenSignatureSettings.initialDialogSettings : this.pdfViewer.initialDialogSettings) &&
                    (this.pdfViewer.handWrittenSignatureSettings.initialDialogSettings ?
                        this.pdfViewer.handWrittenSignatureSettings.initialDialogSettings.displayMode :
                        this.pdfViewer.initialDialogSettings.displayMode), appearanceDiv, typeDiv, uploadDiv);
            }
            else {
                items = this.showHideSignatureTab((this.pdfViewer.handWrittenSignatureSettings.signatureDialogSettings ?
                    this.pdfViewer.handWrittenSignatureSettings.signatureDialogSettings :
                    this.pdfViewer.signatureDialogSettings) && (this.pdfViewer.handWrittenSignatureSettings.signatureDialogSettings ?
                    this.pdfViewer.handWrittenSignatureSettings.signatureDialogSettings.displayMode :
                    this.pdfViewer.signatureDialogSettings.displayMode), appearanceDiv, typeDiv, uploadDiv);
            }
        }
        else {
            if (this.pdfViewerBase.isInitialField) {
                items = this.showHideSignatureTab((this.pdfViewer.initialFieldSettings.initialDialogSettings ?
                    this.pdfViewer.initialFieldSettings.initialDialogSettings.displayMode : 7), appearanceDiv, typeDiv, uploadDiv);
            }
            else {
                items = this.showHideSignatureTab((this.pdfViewer.signatureFieldSettings.signatureDialogSettings ?
                    this.pdfViewer.signatureFieldSettings.signatureDialogSettings.displayMode : 7), appearanceDiv, typeDiv, uploadDiv);
            }
        }
        this.tabObj = new Tab({
            selected: (args) => {
                proxy.handleSelectEvent(args);
            },
            selecting: (args) => {
                proxy.select(args);
            },
            items: items
        });
        this.tabObj.appendTo(tab);
        if (items[0].header.label === 'DRAW') {
            this.signaturetype = 'Draw';
        }
        else if (items[0].header.label === 'TYPE') {
            this.signaturetype = 'Type';
        }
        else {
            this.signaturetype = 'Image';
        }
        return tab;
        // } else {
        //     return appearanceDiv;
        // }
    }
    //to set custom fonts for specific settings
    setCustomFonts() {
        if (!this.pdfViewerBase.isToolbarSignClicked && !isNullOrUndefined(this.pdfViewer.signatureFieldSettings.typeSignatureFonts)) {
            if (!this.pdfViewerBase.isInitialField) {
                for (let j = 0; j < 4; j++) {
                    if (!isNullOrUndefined(this.pdfViewer.signatureFieldSettings.typeSignatureFonts[parseInt(j.toString(), 10)])) {
                        this.signfontStyle[parseInt(j.toString(), 10)].FontName =
                            this.pdfViewer.signatureFieldSettings.typeSignatureFonts[parseInt(j.toString(), 10)];
                    }
                }
            }
        }
        if (!this.pdfViewerBase.isToolbarSignClicked && !isNullOrUndefined(this.pdfViewer.initialFieldSettings.typeInitialFonts)) {
            if (this.pdfViewerBase.isInitialField) {
                for (let j = 0; j < 4; j++) {
                    if (!isNullOrUndefined(this.pdfViewer.initialFieldSettings.typeInitialFonts[parseInt(j.toString(), 10)])) {
                        this.signfontStyle[parseInt(j.toString(), 10)].FontName =
                            this.pdfViewer.initialFieldSettings.typeInitialFonts[parseInt(j.toString(), 10)];
                    }
                }
            }
        }
    }
    handleSelectEvent(e) {
        let headerText = '';
        const maximumWidth = 750;
        const tabInstance = document.getElementById(this.pdfViewer.element.id + 'Signature_tab').ej2_instances[0];
        if (tabInstance) {
            if (tabInstance.items.length > 0) {
                for (let i = 0; i < tabInstance.items.length; i++) {
                    const headerValue = tabInstance.items[parseInt(i.toString(), 10)].header.text;
                    if (headerValue === e.selectedItem.textContent) {
                        headerText = tabInstance.items[parseInt(i.toString(), 10)].header.label;
                    }
                }
            }
        }
        this.clearSignatureCanvas(e);
        if (headerText.toLocaleLowerCase() === 'draw') {
            this.signaturetype = 'Draw';
            this.enableCreateSignatureButton();
            const drawCheckbox = document.getElementById('checkbox');
            this.hideSignatureCheckbox(drawCheckbox);
        }
        else if (headerText.toLocaleLowerCase() === 'type') {
            const canvas = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
            if (canvas) {
                this.drawSignatureDataUrl = canvas.toDataURL();
            }
            this.updateSignatureTypeValue();
            this.signaturetype = 'Type';
            this.enableCreateSignatureButton();
            const typeCheckbox = document.getElementById('checkbox1');
            this.hideSignatureCheckbox(typeCheckbox);
            const textbox = document.getElementById(this.pdfViewer.element.id + '_e-pv-Signtext-box');
            if (!this.pdfViewerBase.isInitialField && this.saveSignatureTypeString !== '' && textbox.value !== '' && !this.pdfViewerBase.isToolbarSignClicked) {
                this.renderSignatureText();
            }
            else if (this.pdfViewerBase.isInitialField && this.saveInitialTypeString !== '' && textbox.value !== '' && !this.pdfViewerBase.isToolbarSignClicked) {
                this.renderSignatureText();
            }
        }
        else if (headerText.toLocaleLowerCase() === 'upload') {
            const canvas = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
            if (canvas) {
                this.drawSignatureDataUrl = canvas.toDataURL();
            }
            this.signaturetype = 'Image';
            this.enableCreateSignatureButton();
            const imageCheckbox = document.getElementById('checkbox2');
            this.hideSignatureCheckbox(imageCheckbox);
            const signbutton = document.getElementById(this.pdfViewer.element.id + '_e-pv-upload-button');
            if (this.saveSignatureUploadString !== '' && !this.pdfViewerBase.isInitialField && !this.clearUploadString && !this.pdfViewerBase.isToolbarSignClicked) {
                this.enableCreateButton(false);
                signbutton.style.visibility = 'hidden';
                this.outputString = this.saveSignatureUploadString;
            }
            if (this.saveInitialUploadString !== '' && this.pdfViewerBase.isInitialField && !this.clearUploadString && !this.pdfViewerBase.isToolbarSignClicked) {
                this.enableCreateButton(false);
                signbutton.style.visibility = 'hidden';
                this.outputString = this.saveInitialUploadString;
            }
        }
        if (this.pdfViewer.element.offsetWidth < maximumWidth) {
            this.updateCanvasSize();
        }
        this.drawSignOnTabSwitch();
        if (headerText.toLocaleLowerCase() === 'upload' && this.imageSignatureDataUrl) {
            this.imageSignOnTabSwitch();
        }
    }
    enableCreateSignatureButton() {
        if (this.pdfViewerBase.isToolbarSignClicked || this.signaturetype !== 'Type') {
            if (this.outputString !== '') {
                this.enableCreateButton(false);
            }
            else {
                this.enableCreateButton(true);
            }
        }
        else {
            if (this.textValue !== '') {
                this.enableCreateButton(false);
            }
            else {
                this.enableCreateButton(true);
            }
        }
    }
    showHideSignatureTab(displayMode, appearanceDiv, typeDiv, uploadDiv) {
        const items = [];
        if (displayMode & DisplayMode.Draw) {
            items.push({
                header: { 'text': this.pdfViewer.localeObj.getConstant('Draw-hand Signature'), 'label': 'DRAW' },
                content: appearanceDiv
            });
        }
        if (displayMode & DisplayMode.Text) {
            items.push({
                header: { 'text': this.pdfViewer.localeObj.getConstant('Type Signature'), 'label': 'TYPE' },
                content: typeDiv
            });
        }
        if (displayMode & DisplayMode.Upload) {
            items.push({
                header: { 'text': this.pdfViewer.localeObj.getConstant('Upload Signature'), 'label': 'UPLOAD' },
                content: uploadDiv
            });
        }
        return items;
    }
    /**
     * @private
     * @returns {void}
     */
    createSignatureFileElement() {
        const signImage = createElement('input', { id: this.pdfViewer.element.id + '_signElement', attrs: { 'type': 'file' } });
        signImage.setAttribute('accept', '.jpg,.jpeg,.png');
        signImage.style.position = 'absolute';
        signImage.style.left = '0px';
        signImage.style.top = '0px';
        signImage.style.visibility = 'hidden';
        document.body.appendChild(signImage);
        signImage.addEventListener('change', this.addStampImage);
    }
    uploadSignatureImage() {
        let signImage = document.getElementById(this.pdfViewer.element.id + '_signElement');
        if (isNullOrUndefined(signImage)) {
            this.createSignatureFileElement();
            signImage = document.getElementById(this.pdfViewer.element.id + '_signElement');
        }
        if (signImage) {
            signImage.click();
        }
    }
    renderSignatureText() {
        const maximumWidth = 750;
        let enableButtons;
        const fontDiv = document.getElementById(this.pdfViewer.element.id + '_font_appearance');
        const textBox = document.getElementById(this.pdfViewer.element.id + '_e-pv-Signtext-box');
        for (let i = 0; i < this.signfontStyle.length; i++) {
            this.fontsign[parseInt(i.toString(), 10)].innerHTML = textBox.value;
            this.fontsign[parseInt(i.toString(), 10)].style.fontFamily = this.signfontStyle[parseInt(i.toString(), 10)].FontName;
            if (this.fontName !== '' && this.signfontStyle[parseInt(i.toString(), 10)].FontName === this.fontName) {
                this.fontsign[parseInt(i.toString(), 10)].classList.add('e-pv-selected-fontdiv');
                this.fontsign[parseInt(i.toString(), 10)].style.borderColor = 'red';
            }
            else if (isNullOrUndefined(this.fontName) &&
                !isNullOrUndefined(this.signfontStyle[parseInt(i.toString(), 10)].FontName) && i === 0) {
                this.fontsign[parseInt(i.toString(), 10)].classList.add('e-pv-selected-fontdiv');
                this.fontsign[parseInt(i.toString(), 10)].style.borderColor = 'red';
            }
            fontDiv.appendChild(this.fontsign[parseInt(i.toString(), 10)]);
        }
        for (let i = 0; i < this.signfontStyle.length; i++) {
            const clickSign = document.getElementById('_font_signature' + i + '');
            clickSign.addEventListener('click', this.typeSignatureclick.bind(this));
        }
        if (textBox.value.trim() === '') {
            enableButtons = true;
        }
        else {
            enableButtons = false;
        }
        this.enableCreateButton(enableButtons);
        this.enableClearbutton(enableButtons);
        if (this.pdfViewer.element.offsetWidth < maximumWidth) {
            this.updateCanvasSize();
        }
        this.drawSignOnTabSwitch();
    }
    typeSignatureclick() {
        const eventTarget = event.target;
        if (eventTarget.textContent.trim() !== '') {
            const createButton = document.getElementsByClassName('e-pv-createbtn')[0];
            createButton.disabled = false;
            for (let i = 0; i < 4; i++) {
                const fontElement = document.getElementById('_font_signature' + i + '');
                if (fontElement) {
                    fontElement.style.borderColor = '';
                    fontElement.classList.remove('e-pv-selected-fontdiv');
                }
            }
            eventTarget.classList.add('e-pv-selected-fontdiv');
            eventTarget.style.borderColor = 'red';
            this.outputString = eventTarget.textContent;
            try {
                this.fontName = JSON.parse(eventTarget.style.fontFamily);
            }
            catch (e) {
                this.fontName = eventTarget.style.fontFamily;
            }
        }
    }
    /**
     * @param {any} bounds - It describes about the bounds value
     * @param {any} position - It describes about the position
     * @private
     * @returns {void}
     */
    addSignatureCollection(bounds, position) {
        let minimumX = -1;
        let minimumY = -1;
        let maximumX = -1;
        let maximumY = -1;
        const collectionData = processPathData(this.outputString);
        const newCanvas = document.createElement('canvas');
        const context = newCanvas.getContext('2d');
        let imageString;
        const signatureType = this.pdfViewerBase.currentSignatureAnnot.shapeAnnotationType;
        if (signatureType === 'HandWrittenSignature') {
            if (collectionData.length !== 0) {
                for (let k = 0; k < collectionData.length; k++) {
                    const val = collectionData[parseInt(k.toString(), 10)];
                    if (minimumX === -1) {
                        minimumX = (val['x']);
                        maximumX = (val['x']);
                        minimumY = (val['y']);
                        maximumY = (val['y']);
                    }
                    else {
                        const point1 = (val['x']);
                        const point2 = (val['y']);
                        if (minimumX >= point1) {
                            minimumX = point1;
                        }
                        if (minimumY >= point2) {
                            minimumY = point2;
                        }
                        if (maximumX <= point1) {
                            maximumX = point1;
                        }
                        if (maximumY <= point2) {
                            maximumY = point2;
                        }
                    }
                }
                const newdifferenceX = maximumX - minimumX;
                const newdifferenceY = maximumY - minimumY;
                let differenceX = newdifferenceX / 100;
                let differenceY = newdifferenceY / 100;
                let left = 0;
                let top = 0;
                if (bounds) {
                    newCanvas.width = position.currentWidth;
                    newCanvas.height = position.currentHeight;
                    differenceX = newdifferenceX / (bounds.width);
                    differenceY = newdifferenceY / (bounds.height);
                    left = bounds.x - position.currentLeft;
                    top = bounds.y - position.currentTop;
                }
                else {
                    newCanvas.width = 100;
                    newCanvas.height = 100;
                }
                context.beginPath();
                for (let n = 0; n < collectionData.length; n++) {
                    const val = collectionData[parseInt(n.toString(), 10)];
                    const point1 = ((val['x'] - minimumX) / differenceX) + left;
                    const point2 = ((val['y'] - minimumY) / differenceY) + top;
                    if (val['command'] === 'M') {
                        context.moveTo(point1, point2);
                    }
                    else if (val['command'] === 'L') {
                        context.lineTo(point1, point2);
                    }
                }
                context.stroke();
                context.closePath();
                imageString = newCanvas.toDataURL();
            }
        }
        else if (signatureType === 'SignatureText') {
            imageString = this.outputString;
        }
        else {
            imageString = this.outputString;
        }
        if (bounds) {
            this.saveImageString = imageString;
        }
        else {
            const signCollection = {};
            signCollection['sign_' + this.pdfViewerBase.imageCount] = this.outputString;
            this.outputcollection.push(signCollection);
            const signBounds = {};
            signBounds['height'] = this.pdfViewerBase.currentSignatureAnnot.bounds.height;
            signBounds['width'] = this.pdfViewerBase.currentSignatureAnnot.bounds.width;
            const signature = [];
            signature.push({ id: 'sign_' + this.pdfViewerBase.imageCount, imageData: imageString, signatureType: signatureType, fontFamily: this.pdfViewerBase.currentSignatureAnnot.fontFamily, bounds: signBounds });
            this.signaturecollection.push({ image: signature, isInitial: this.pdfViewerBase.isInitialField });
            this.pdfViewerBase.imageCount++;
        }
    }
    /**
     * @private]
     * @param {number} limit - The limit.
     * @returns {number} - Returns number.
     */
    getSaveLimit(limit) {
        if (limit > this.maxSaveLimit) {
            limit = this.maxSaveLimit;
        }
        else if (limit < 1) {
            limit = 1;
        }
        return limit;
    }
    /**
     * @private
     * @returns {void}
     */
    RenderSavedSignature() {
        this.pdfViewerBase.signatureCount++;
        const zoomvalue = this.pdfViewerBase.getZoomFactor();
        let annot;
        if (this.pdfViewerBase.isAddedSignClicked) {
            const annotationName = this.pdfViewer.annotation.createGUID();
            this.pdfViewerBase.currentSignatureAnnot = null;
            this.pdfViewerBase.isSignatureAdded = true;
            const pageIndex = this.pdfViewerBase.currentPageNumber - 1;
            const pageDiv = document.getElementById(this.pdfViewer.element.id + '_pageDiv_' + pageIndex);
            let currentLeft = 0;
            let currentTop = 0;
            let currentWidth = this.pdfViewer.handWrittenSignatureSettings.width ?
                this.pdfViewer.handWrittenSignatureSettings.width : 100;
            let currentHeight = this.pdfViewer.handWrittenSignatureSettings.height ?
                this.pdfViewer.handWrittenSignatureSettings.height : 100;
            const thickness = this.pdfViewer.handWrittenSignatureSettings.thickness ?
                this.pdfViewer.handWrittenSignatureSettings.thickness : 1;
            const opacity = this.pdfViewer.handWrittenSignatureSettings.opacity ?
                this.pdfViewer.handWrittenSignatureSettings.opacity : 1;
            const strokeColor = this.pdfViewer.handWrittenSignatureSettings.strokeColor ? this.pdfViewer.handWrittenSignatureSettings.strokeColor : '#000000';
            currentLeft = ((parseFloat(pageDiv.style.width) / 2) - (currentWidth / 2)) / zoomvalue;
            currentTop = ((parseFloat(pageDiv.style.height) / 2) - (currentHeight / 2)) / zoomvalue;
            let keyString = '';
            let signatureType;
            let signatureFontFamily;
            let bounds;
            for (let collection = 0; collection < this.outputcollection.length; collection++) {
                const collectionAddedsign = this.outputcollection[parseInt(collection.toString(), 10)];
                const eventTarget = event.target;
                if (eventTarget && eventTarget.id === 'sign_' + collection || eventTarget && eventTarget.id === 'sign_border' + collection) {
                    keyString = collectionAddedsign['sign_' + collection];
                    break;
                }
            }
            for (let signatureIndex = 0; signatureIndex < this.signaturecollection.length; signatureIndex++) {
                const eventTarget = event.target;
                const signatureId = this.signaturecollection[parseInt(signatureIndex.toString(), 10)].image[0].id.split('_')[1];
                if (eventTarget && eventTarget.id === 'sign_' + signatureId || eventTarget && eventTarget.id === 'sign_border' + signatureId) {
                    signatureType = this.signaturecollection[parseInt(signatureIndex.toString(), 10)].image[0].signatureType;
                    signatureFontFamily = this.signaturecollection[parseInt(signatureIndex.toString(), 10)].image[0].fontFamily;
                    bounds = this.signaturecollection[parseInt(signatureIndex.toString(), 10)].image[0].bounds;
                    break;
                }
            }
            if (signatureType === 'HandWrittenSignature') {
                const signatureBounds = this.updateSignatureAspectRatio(keyString, true);
                if (bounds.width !== signatureBounds.width && bounds.height !== signatureBounds.height) {
                    currentWidth = bounds.width;
                    currentHeight = bounds.height;
                }
                else {
                    currentWidth = signatureBounds.width ? signatureBounds.width : currentWidth;
                    currentHeight = signatureBounds.height ? signatureBounds.height : currentHeight;
                }
            }
            else {
                currentWidth = bounds.width;
                currentHeight = bounds.height;
            }
            annot = {
                id: 'sign' + this.pdfViewerBase.signatureCount, bounds: { x: currentLeft, y: currentTop, width: currentWidth, height: currentHeight }, pageIndex: pageIndex, data: keyString,
                shapeAnnotationType: signatureType, opacity: opacity, fontFamily: signatureFontFamily, strokeColor: strokeColor,
                thickness: thickness, signatureName: annotationName
            };
            this.pdfViewerBase.currentSignatureAnnot = annot;
            this.pdfViewerBase.isAddedSignClicked = false;
        }
        else {
            if (this.pdfViewer.formFieldsModule) {
                this.pdfViewer.formFieldsModule.drawSignature();
            }
        }
    }
    /**
     * @private
     * @returns {void}
     */
    updateCanvasSize() {
        const canvas = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
        this.setTabItemWidth(canvas);
        const uploadCanvas = document.getElementById(this.pdfViewer.element.id + '_signatureuploadCanvas_');
        this.setTabItemWidth(uploadCanvas);
        const fontAppearance = document.getElementById(this.pdfViewer.element.id + '_font_appearance');
        this.setTabItemWidth(fontAppearance);
    }
    setTabItemWidth(canvas) {
        let padding = 2;
        const maximumWidth = 750;
        const canvasWidth = 714;
        const margin = 50;
        const elem = document.querySelector('.e-dlg-content');
        if (elem) {
            const style = getComputedStyle(elem);
            padding = padding + parseInt(style.paddingLeft, 10) + parseInt(style.paddingRight, 10);
        }
        if (canvas && this.signatureDialog && this.signatureDialog.visible) {
            if (canvas.tagName !== 'DIV') {
                const context = canvas.getContext('2d');
                const canvasContent = canvas.toDataURL();
                const image = new Image();
                image.src = canvasContent;
                image.onload = () => {
                    context.drawImage(image, 0, 0, canvas.width, canvas.height);
                };
            }
            if (this.pdfViewer.element.parentElement.clientWidth > maximumWidth) {
                canvas.width = canvasWidth;
                canvas.style.width = canvasWidth + 'px';
            }
            else {
                canvas.width = this.pdfViewer.element.parentElement.clientWidth - padding;
                canvas.style.width = canvas.width + 'px';
            }
        }
        const fontInnerDiv = document.getElementsByClassName('e-pv-font-sign');
        if (canvas && fontInnerDiv && fontInnerDiv.length > 0) {
            for (let i = 0; i < fontInnerDiv.length; i++) {
                const fontDiv = fontInnerDiv[parseInt(i.toString(), 10)];
                fontDiv.style.width = ((canvas.width / 2) - margin) + 'px';
            }
        }
    }
    drawSignOnTabSwitch() {
        // eslint-disable-next-line
        const proxy = this;
        const image = new Image();
        image.onload = () => {
            const canvas = document.getElementById(proxy.pdfViewer.element.id + '_signatureCanvas_');
            if (canvas) {
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0);
            }
        };
        image.src = this.drawSignatureDataUrl;
    }
    imageSignOnTabSwitch() {
        // eslint-disable-next-line
        const proxy = this;
        const image = new Image();
        image.onload = function () {
            const canvas = document.getElementById(proxy.pdfViewer.element.id + '_signatureuploadCanvas_');
            if (canvas) {
                const context = canvas.getContext('2d');
                const signbutton = document.getElementById(proxy.pdfViewer.element.id + '_e-pv-upload-button');
                signbutton.style.visibility = 'hidden';
                context.drawImage(image, 0, 0, canvas.width, canvas.height);
                proxy.enableCreateButton(false);
                proxy.signatureImageHeight = image.naturalHeight;
                proxy.signatureImageWidth = image.naturalWidth;
            }
        };
        image.src = this.imageSignatureDataUrl;
    }
    signaturePanelMouseDown(e) {
        if (e.type !== 'contextmenu') {
            e.preventDefault();
            this.findMousePosition(e);
            this.mouseDetection = true;
            this.oldX = this.mouseX;
            this.oldY = this.mouseY;
            this.newObject = [];
            this.drawMousePosition(e);
            this.mouseMoving = true;
        }
    }
    enableCreateButton(isEnable) {
        const createbtn = document.getElementsByClassName('e-pv-createbtn')[0];
        if (createbtn) {
            createbtn.disabled = isEnable;
        }
        this.enableClearbutton(isEnable);
    }
    enableClearbutton(isEnable) {
        const clearbtn = document.getElementsByClassName('e-pv-clearbtn')[0];
        if (clearbtn) {
            clearbtn.disabled = isEnable;
        }
    }
    signaturePanelMouseMove(e) {
        if (this.mouseDetection && this.signaturetype === 'Draw') {
            this.findMousePosition(e);
            this.enableCreateButton(false);
            this.drawMousePosition(e);
        }
    }
    findMousePosition(event) {
        let offsetX;
        let offsetY;
        if (event.type.indexOf('touch') !== -1) {
            event = event;
            const element = event.target;
            const currentRect = element.getBoundingClientRect();
            this.mouseX = event.changedTouches[0].clientX - currentRect.left;
            this.mouseY = event.changedTouches[0].clientY - currentRect.top;
        }
        else {
            event = event;
            this.mouseX = event.offsetX;
            this.mouseY = event.offsetY;
        }
    }
    drawMousePosition(event) {
        if (this.mouseDetection) {
            this.drawSignatureInCanvas();
            this.oldX = this.mouseX;
            this.oldY = this.mouseY;
        }
    }
    drawSignatureInCanvas() {
        const canvas = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
        const context = canvas.getContext('2d');
        context.beginPath();
        context.moveTo(this.oldX, this.oldY);
        context.lineTo(this.mouseX, this.mouseY);
        context.stroke();
        context.lineWidth = 2;
        context.arc(this.oldX, this.oldY, 2 / 2, 0, Math.PI * 2, true);
        context.closePath();
        this.newObject.push(this.mouseX, this.mouseY);
    }
    signaturePanelMouseUp() {
        if (this.mouseDetection) {
            this.convertToPath(this.newObject);
        }
        this.mouseDetection = false;
        if (event.type === 'touchend') {
            this.canvasTouched = true;
        }
    }
    signaturePanelMouseLeave() {
        if (this.mouseDetection) {
            this.convertToPath(this.newObject);
        }
        this.mouseDetection = false;
        this.mouseMoving = false;
    }
    convertToPath(newObject) {
        this.movePath(newObject[0], newObject[1]);
        this.linePath(newObject[0], newObject[1]);
        for (let n = 2; n < newObject.length; n = n + 2) {
            this.linePath(newObject[parseInt(n.toString(), 10)], newObject[n + 1]);
        }
    }
    linePath(x, y) {
        this.outputString += 'L' + x + ',' + y + ' ';
    }
    movePath(x, y) {
        this.outputString += 'M' + x + ',' + y + ' ';
    }
    /**
     * @param {any} type - It describes about the type
     * @private
     * @returns {void}
     */
    clearSignatureCanvas(type) {
        let isCanvasClear = true;
        let drawObject = [];
        if (type && !isNullOrUndefined(type.previousIndex) && !isNullOrUndefined(type.selectedIndex)) {
            isCanvasClear = false;
            if (type.previousIndex === 0) {
                this.drawOutputString = this.outputString;
                drawObject = this.newObject;
            }
            else if (type.previousIndex === 2) {
                this.imageOutputString = this.outputString;
            }
            this.outputString = '';
            this.newObject = [];
            if (type.selectedIndex === 0) {
                this.outputString = this.drawOutputString;
                this.newObject = drawObject;
            }
            else if (type.selectedIndex === 2) {
                this.outputString = this.imageOutputString;
            }
        }
        else {
            this.outputString = '';
            this.newObject = [];
        }
        let isClearDrawTab = false;
        let isClearTypeTab = false;
        let isClearImageTab = false;
        if (type && type.currentTarget && type.currentTarget.classList.contains('e-pv-clearbtn')) {
            isCanvasClear = false;
            if (this.signaturetype === 'Draw') {
                isClearDrawTab = true;
                const checkbox = document.getElementById('checkbox');
                const checkBoxElement = document.getElementById('checkbox');
                if (checkbox && checkBoxElement.nextElementSibling) {
                    checkBoxElement.nextElementSibling.classList.remove('e-check');
                    checkbox.checked = false;
                }
            }
            else if (this.signaturetype === 'Type') {
                isClearTypeTab = true;
                const checkbox = document.getElementById('checkbox1');
                const checkBoxElement = document.getElementById('checkbox1');
                if (checkbox && checkBoxElement.nextElementSibling) {
                    checkBoxElement.nextElementSibling.classList.remove('e-check');
                    checkbox.checked = false;
                    this.textValue = '';
                }
            }
            else {
                isClearImageTab = true;
                this.clearUploadString = true;
                const checkbox = document.getElementById('checkbox2');
                const checkBoxElement = document.getElementById('checkbox2');
                if (checkbox && checkBoxElement.nextElementSibling) {
                    checkBoxElement.nextElementSibling.classList.remove('e-check');
                    checkbox.checked = false;
                }
            }
        }
        const canvas = document.getElementById(this.pdfViewer.element.id + '_signatureCanvas_');
        if ((canvas && isCanvasClear) || (isClearDrawTab)) {
            const context = canvas.getContext('2d');
            context.clearRect(0, 0, canvas.width, canvas.height);
        }
        const imageCanvas = document.getElementById(this.pdfViewer.element.id + '_signatureuploadCanvas_');
        if (imageCanvas && isCanvasClear || (isClearImageTab)) {
            const context = imageCanvas.getContext('2d');
            context.clearRect(0, 0, imageCanvas.width, imageCanvas.height);
            const signbutton = document.getElementById(this.pdfViewer.element.id + '_e-pv-upload-button');
            if (signbutton) {
                signbutton.style.visibility = '';
            }
        }
        const fontdiv = document.getElementById(this.pdfViewer.element.id + '_font_appearance');
        const textbox = document.getElementById(this.pdfViewer.element.id + '_e-pv-Signtext-box');
        if ((fontdiv && textbox && isCanvasClear) || (isClearTypeTab)) {
            textbox.value = '';
            if (!isBlazor()) {
                fontdiv.innerHTML = '';
            }
        }
        this.enableCreateButton(true);
    }
    /**
     * @private
     * @returns {void}
     */
    closeSignaturePanel() {
        if (this.pdfViewerBase.currentTarget) {
            this.pdfViewerBase.drawSignatureWithTool = true;
        }
        this.clearSignatureCanvas();
        if (!isBlazor()) {
            this.signatureDialog.hide();
        }
        this.pdfViewerBase.isToolbarSignClicked = false;
        this.pdfViewerBase.drawSignatureWithTool = false;
        this.drawOutputString = '';
        this.imageOutputString = '';
    }
    /**
     * @private
     * @returns {string} - Returns the string.
     */
    saveSignature() {
        let storeObject = null;
        if (this.pdfViewerBase.isStorageExceed) {
            storeObject = this.pdfViewerBase.annotationStorage[this.pdfViewerBase.documentId + '_annotations_sign'];
        }
        else {
            storeObject = PdfViewerBase.sessionStorageManager.getItem(this.pdfViewerBase.documentId + '_annotations_sign');
        }
        const annotations = [];
        for (let j = 0; j < this.pdfViewerBase.pageCount; j++) {
            annotations[parseInt(j.toString(), 10)] = [];
        }
        if (storeObject) {
            const annotationCollection = JSON.parse(storeObject);
            for (let i = 0; i < annotationCollection.length; i++) {
                let newArray = [];
                const pageAnnotationObject = annotationCollection[parseInt(i.toString(), 10)];
                if (pageAnnotationObject) {
                    for (let z = 0; pageAnnotationObject.annotations.length > z; z++) {
                        if (this.pdfViewer.isSignatureEditable) {
                            const signatureSettings = this.pdfViewer.handWrittenSignatureSettings;
                            const annotationSettings = this.pdfViewer.annotationSettings;
                            const annotationAuthor = (signatureSettings.author !== 'Guest') ? signatureSettings.author : annotationSettings.author ? annotationSettings.author : 'Guest';
                            pageAnnotationObject.annotations[parseInt(z.toString(), 10)].author = annotationAuthor;
                        }
                        const strokeColorString = pageAnnotationObject.annotations[parseInt(z.toString(), 10)].strokeColor ? pageAnnotationObject.annotations[parseInt(z.toString(), 10)].strokeColor : 'black';
                        pageAnnotationObject.annotations[parseInt(z.toString(), 10)].strokeColor =
                            JSON.stringify(this.getRgbCode(strokeColorString));
                        pageAnnotationObject.annotations[parseInt(z.toString(), 10)].bounds =
                            JSON.stringify(this.pdfViewer.annotation.
                                getBounds(pageAnnotationObject.annotations[parseInt(z.toString(), 10)].bounds, pageAnnotationObject.pageIndex));
                        if (pageAnnotationObject.annotations[parseInt(z.toString(), 10)].shapeAnnotationType === 'HandWrittenSignature' || pageAnnotationObject.annotations[parseInt(z.toString(), 10)].signatureName === 'ink') {
                            const collectionData = processPathData(pageAnnotationObject.annotations[parseInt(z.toString(), 10)].data);
                            const csData = splitArrayCollection(collectionData);
                            pageAnnotationObject.annotations[parseInt(z.toString(), 10)].data = JSON.stringify(csData);
                        }
                        else {
                            if (pageAnnotationObject.annotations[parseInt(z.toString(), 10)].shapeAnnotationType === 'SignatureText' && !this.checkDefaultFont(pageAnnotationObject.annotations[parseInt(z.toString(), 10)].fontFamily)) {
                                const signTypeCanvas = createElement('canvas');
                                const bounds = JSON.parse(pageAnnotationObject.annotations[parseInt(z.toString(), 10)].bounds);
                                const scaleFactor = 3;
                                const fontSize = pageAnnotationObject.annotations[parseInt(z.toString(), 10)].fontSize;
                                const width = (bounds && bounds.width) || 150;
                                const height = (bounds && bounds.height) || (fontSize * 2.5);
                                signTypeCanvas.width = width * scaleFactor;
                                signTypeCanvas.height = height * scaleFactor;
                                const canvasContext = signTypeCanvas.getContext('2d');
                                canvasContext.scale(scaleFactor, scaleFactor);
                                canvasContext.textRendering = 'optimizeLegibility';
                                canvasContext.imageSmoothingEnabled = true;
                                canvasContext.imageSmoothingQuality = 'high';
                                canvasContext.textAlign = 'center';
                                canvasContext.font = fontSize + 'px ' + pageAnnotationObject.annotations[parseInt(z.toString(), 10)].fontFamily;
                                const x = width / 2;
                                const y = (height / 2) + (fontSize * 0.4);
                                canvasContext.fillText(pageAnnotationObject.annotations[parseInt(z.toString(), 10)].data, x, y);
                                pageAnnotationObject.annotations[parseInt(z.toString(), 10)].data = JSON.stringify(signTypeCanvas.toDataURL('image/png', 1.0));
                                pageAnnotationObject.annotations[parseInt(z.toString(), 10)].shapeAnnotationType = 'SignatureImage';
                            }
                            else {
                                pageAnnotationObject.annotations[parseInt(z.toString(), 10)].data =
                                    JSON.stringify(pageAnnotationObject.annotations[parseInt(z.toString(), 10)].data);
                            }
                        }
                    }
                    newArray = pageAnnotationObject.annotations;
                }
                annotations[pageAnnotationObject.pageIndex] = newArray;
            }
        }
        return JSON.stringify(annotations);
    }
    /**
     *
     * @private
     * @returns {boolean}
     */
    checkDefaultFont(fontName) {
        if (fontName === 'Helvetica' || fontName === 'Times New Roman' || fontName === 'Courier' || fontName === 'Symbol') {
            return true;
        }
        return false;
    }
    /**
     * @param {string} colorString - It describes about the color string value
     * @private
     * @returns {any} - any
     */
    getRgbCode(colorString) {
        /* eslint-disable-next-line security/detect-unsafe-regex */
        if (!colorString.match(/#([a-z0-9]+)/gi) && !colorString.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)) {
            colorString = this.pdfViewer.annotationModule.nameToHash(colorString);
        }
        let stringArray = colorString.split(',');
        if (isNullOrUndefined(stringArray[1])) {
            colorString = this.pdfViewer.annotationModule.getValue(colorString, 'rgba');
            stringArray = colorString.split(',');
        }
        const r = parseInt(stringArray[0].split('(')[1], 10);
        const g = parseInt(stringArray[1], 10);
        const b = parseInt(stringArray[2], 10);
        const a = parseInt(stringArray[3], 10);
        return { r: r, g: g, b: b, a: a };
    }
    /**
     * @private
     * @param {number} left - The left.
     * @param {number} top - The top.
     * @returns {void}
     */
    renderSignature(left, top) {
        let annot;
        let signatureData = '';
        const currentAnnotation = this.pdfViewerBase.currentSignatureAnnot;
        let annotationName = currentAnnotation.signatureName;
        if (annotationName === '' || isNullOrUndefined(annotationName)) {
            annotationName = this.pdfViewer.annotation.createGUID();
        }
        if (currentAnnotation) {
            if (this.pdfViewerBase.currentSignatureAnnot.shapeAnnotationType === 'HandWrittenSignature') {
                annot = {
                    id: currentAnnotation.id, bounds: { x: left, y: top, width: currentAnnotation.bounds.width,
                        height: currentAnnotation.bounds.height }, pageIndex: currentAnnotation.pageIndex, data: currentAnnotation.data,
                    shapeAnnotationType: 'HandWrittenSignature', opacity: currentAnnotation.opacity, fontFamily: currentAnnotation.fontFamily, fontSize: currentAnnotation.fontSize, strokeColor: currentAnnotation.strokeColor, thickness: currentAnnotation.thickness, signatureName: annotationName
                };
            }
            if (this.pdfViewerBase.currentSignatureAnnot.shapeAnnotationType === 'SignatureText') {
                annot = {
                    id: currentAnnotation.id, bounds: { x: left, y: top, width: currentAnnotation.bounds.width,
                        height: currentAnnotation.bounds.height }, pageIndex: currentAnnotation.pageIndex, data: currentAnnotation.data,
                    shapeAnnotationType: 'SignatureText', opacity: currentAnnotation.opacity, fontFamily: currentAnnotation.fontFamily, fontSize: currentAnnotation.fontSize, strokeColor: currentAnnotation.strokeColor, thickness: currentAnnotation.thickness, signatureName: annotationName
                };
            }
            else if (this.pdfViewerBase.currentSignatureAnnot.shapeAnnotationType === 'SignatureImage') {
                annot = {
                    id: currentAnnotation.id, bounds: { x: left, y: top, width: currentAnnotation.bounds.width,
                        height: currentAnnotation.bounds.height }, pageIndex: currentAnnotation.pageIndex, data: currentAnnotation.data,
                    shapeAnnotationType: 'SignatureImage', opacity: currentAnnotation.opacity, fontFamily: currentAnnotation.fontFamily, fontSize: currentAnnotation.fontSize, strokeColor: currentAnnotation.strokeColor, thickness: currentAnnotation.thickness, signatureName: annotationName
                };
            }
            const obj = this.pdfViewer.add(annot);
            const canvass = this.pdfViewerBase.getAnnotationCanvas('_annotationCanvas_', currentAnnotation.pageIndex);
            this.pdfViewer.renderDrawing(canvass, currentAnnotation.pageIndex);
            if (Browser.isDevice && !this.pdfViewer.enableDesktopMode) {
                this.pdfViewer.select([obj.id]);
            }
            this.pdfViewerBase.signatureAdded = true;
            this.storeSignatureData(currentAnnotation.pageIndex, annot);
            if (this.signaturetype === 'Draw') {
                signatureData = this.saveImageString;
            }
            else {
                signatureData = currentAnnotation.data;
            }
            this.pdfViewer.fireSignatureAdd(currentAnnotation.pageIndex, annotationName, currentAnnotation.shapeAnnotationType, currentAnnotation.bounds, currentAnnotation.opacity, currentAnnotation.strokeColor, currentAnnotation.thickness, signatureData);
            if (this.pdfViewer.annotation) {
                this.pdfViewer.annotation.onAnnotationMouseDown();
            }
            this.pdfViewerBase.currentSignatureAnnot = null;
            this.pdfViewerBase.signatureCount++;
        }
    }
    /**
     * @param {any} annotationCollection - It describes about the annotation collection
     * @param {number} pageIndex - It describes about the page index
     * @param {boolean} isImport - It describes about the whether the isImport is true or not
     * @param {boolean} isLastAnnot - It describes about the whether the isLastAnnot is true or not
     * @private
     * @returns {void}
     */
    renderExistingSignature(annotationCollection, pageIndex, isImport, isLastAnnot) {
        let annot;
        let isAnnotationAdded = false;
        if (!isImport) {
            for (let p = 0; p < this.signAnnotationIndex.length; p++) {
                if (this.signAnnotationIndex[parseInt(p.toString(), 10)] === pageIndex) {
                    isAnnotationAdded = true;
                    break;
                }
            }
        }
        if (annotationCollection && !isAnnotationAdded) {
            if (annotationCollection.length > 0 && this.signAnnotationIndex.indexOf(pageIndex) === -1) {
                this.signAnnotationIndex.push(pageIndex);
            }
            for (let n = 0; n < annotationCollection.length; n++) {
                const currentAnnotation = annotationCollection[parseInt(n.toString(), 10)];
                if (currentAnnotation) {
                    let data = currentAnnotation.PathData;
                    if (isImport) {
                        if (currentAnnotation.IsSignature) {
                            data = currentAnnotation.PathData;
                        }
                        else if (currentAnnotation.AnnotationType === 'SignatureImage' || currentAnnotation.AnnotationType === 'SignatureText') {
                            data = JSON.parse(JSON.stringify(currentAnnotation.PathData));
                        }
                        else {
                            if (data.includes('command')) {
                                data = getPathString(JSON.parse(currentAnnotation.PathData));
                            }
                            else {
                                data = currentAnnotation.PathData;
                            }
                        }
                    }
                    this.outputString = data;
                    const calculateInkPosition = this.pdfViewer.annotationModule.inkAnnotationModule.
                        calculateInkSize(this.outputString);
                    this.outputString = '';
                    let rectDiff = 0;
                    let rectDifference = 1;
                    const bounds = currentAnnotation.Bounds;
                    if (calculateInkPosition && (currentAnnotation.AnnotationType === 'Ink' ||
                        currentAnnotation.AnnotationType === 'signature' || currentAnnotation.AnnotationType === 'Signature')) {
                        if (calculateInkPosition.height < 1) {
                            rectDiff = bounds.Height ? bounds.Height : bounds.height;
                            rectDifference = bounds.Height ? bounds.Height : bounds.height;
                        }
                        else if (calculateInkPosition.width < 1) {
                            rectDiff = bounds.Width ? bounds.Width : bounds.width;
                            rectDifference = bounds.Width ? bounds.Width : bounds.width;
                        }
                    }
                    const currentLeft = !isNullOrUndefined(bounds.X) ? bounds.X + (rectDiff / 2) : bounds.x + (rectDiff / 2);
                    const currentTop = !isNullOrUndefined(bounds.Y) ? bounds.Y + (rectDiff / 2) : bounds.y + (rectDiff / 2);
                    const currentWidth = bounds.Width ? bounds.Width - (rectDifference - 1) : bounds.width - (rectDifference - 1);
                    const currentHeight = bounds.Height ? bounds.Height - (rectDifference - 1) :
                        bounds.height - (rectDifference - 1);
                    if (currentAnnotation.AnnotationType === 'SignatureText') {
                        annot = {
                            id: 'sign' + this.pdfViewerBase.signatureCount, bounds: { x: currentLeft, y: currentTop, width: currentWidth, height: currentHeight }, pageIndex: pageIndex, data: data, fontFamily: currentAnnotation.FontFamily, fontSize: currentAnnotation.FontSize,
                            shapeAnnotationType: 'SignatureText', opacity: currentAnnotation.Opacity, strokeColor: currentAnnotation.StrokeColor, thickness: currentAnnotation.Thickness, signatureName: currentAnnotation.SignatureName
                        };
                    }
                    else if (currentAnnotation.AnnotationType === 'SignatureImage') {
                        annot = {
                            id: 'sign' + this.pdfViewerBase.signatureCount, bounds: { x: currentLeft, y: currentTop, width: currentWidth, height: currentHeight }, pageIndex: pageIndex, data: data, shapeAnnotationType: 'SignatureImage', opacity: currentAnnotation.Opacity, strokeColor: currentAnnotation.StrokeColor, thickness: currentAnnotation.Thickness, signatureName: currentAnnotation.SignatureName
                        };
                    }
                    else {
                        annot = {
                            id: 'sign' + this.pdfViewerBase.signatureCount, bounds: { x: currentLeft, y: currentTop, width: currentWidth, height: currentHeight }, pageIndex: pageIndex, data: data, shapeAnnotationType: 'HandWrittenSignature', opacity: currentAnnotation.Opacity, strokeColor: currentAnnotation.StrokeColor, thickness: currentAnnotation.Thickness, signatureName: currentAnnotation.SignatureName ? currentAnnotation.SignatureName : 'ink'
                        };
                    }
                }
                if (annot.shapeAnnotationType === 'SignatureText') {
                    const textWidth = this.pdfViewerBase.getTextWidth(annot.data, annot.fontSize, annot.fontFamily);
                    let widthRatio = 1;
                    if (textWidth > annot.bounds.width) {
                        widthRatio = annot.bounds.width / textWidth;
                    }
                    annot.fontSize = this.pdfViewerBase.getFontSize(Math.floor((annot.fontSize * widthRatio)));
                    const defaultFontSize = 32;
                    annot.bounds.height = annot.fontSize < defaultFontSize ? annot.fontSize * 2 : annot.bounds.height;
                    annot.thickness = 0;
                }
                this.pdfViewer.add(annot);
                if (this.isAddAnnotationProgramatically) {
                    this.pdfViewer.fireSignatureAdd(annot.pageIndex, annot.signatureName, annot.shapeAnnotationType, annot.bounds, annot.opacity, annot.strokeColor, annot.thickness, annot.data);
                }
                const canvasPageIndex = currentAnnotation.pageIndex ? currentAnnotation.pageIndex : currentAnnotation.PageNumber;
                const isNeedToRender = ((isImport && isLastAnnot) || isNullOrUndefined(isImport) ||
                    !isImport) ? true : false;
                if (isNeedToRender) {
                    const canvass = this.pdfViewerBase.getAnnotationCanvas('_annotationCanvas_', canvasPageIndex);
                    this.pdfViewer.renderDrawing(canvass, annot.pageIndex);
                }
                this.storeSignatureData(annot.pageIndex, annot);
                this.pdfViewerBase.currentSignatureAnnot = null;
                this.pdfViewerBase.signatureCount++;
            }
        }
    }
    /**
     * @param {number} pageNumber -It describes about the page number value
     * @param {any} annotations - It describes about the annotations
     * @private
     * @returns {void}
     */
    storeSignatureData(pageNumber, annotations) {
        this.pdfViewer.annotation.addAction(!isNullOrUndefined(annotations.pageIndex) ? annotations.pageIndex : annotations.PageIndex, null, annotations, 'Addition', '', annotations, annotations);
        let annotation = null;
        let left;
        let top;
        let width;
        let height;
        let pageIndex;
        const zoomvalue = this.pdfViewerBase.getZoomFactor();
        if (annotations.bounds) {
            left = annotations.bounds.left ? annotations.bounds.left : annotations.bounds.x;
            top = annotations.bounds.top ? annotations.bounds.top : annotations.bounds.y;
            width = annotations.bounds.width;
            height = annotations.bounds.height;
            pageIndex = annotations.pageIndex;
        }
        else {
            left = annotations.Bounds.left ? annotations.Bounds.left : annotations.Bounds.x;
            top = annotations.Bounds.top ? annotations.Bounds.top : annotations.Bounds.y;
            width = annotations.LineBounds.Width;
            height = annotations.LineBounds.Height;
            pageIndex = annotations.PageIndex;
        }
        if (annotations.wrapper && annotations.wrapper.bounds) {
            left = annotations.wrapper.bounds.left;
            top = annotations.wrapper.bounds.top;
        }
        if (annotations.shapeAnnotationType === 'SignatureText' && annotations.wrapper && annotations.wrapper.children && annotations.wrapper.children.length > 1 && annotations.wrapper.children[1]) {
            left = left + annotations.wrapper.pivot.x + (this.signatureTextContentLeft - (this.signatureTextContentTop *
                (zoomvalue - (zoomvalue / this.signatureTextContentLeft))));
            top = top + ((annotations.wrapper.children[1].bounds.y - top) - (annotations.wrapper.children[1].bounds.y - top) / 3) +
                annotations.wrapper.pivot.y + (this.signatureTextContentTop * zoomvalue);
        }
        annotation = {
            id: annotations.id ? annotations.id : null, bounds: { left: left, top: top, width: width, height: height }, shapeAnnotationType: annotations.shapeAnnotationType ? annotations.shapeAnnotationType : 'ink', opacity: annotations.opacity ? annotations.opacity : 1, thickness: annotations.thickness ? annotations.thickness : 1, strokeColor: annotations.strokeColor ? annotations.strokeColor : null, pageIndex: pageIndex, data: annotations.data ? annotations.data : annotations.Value, fontSize: annotations.fontSize ? annotations.fontSize : null, fontFamily: annotations.fontFamily ? annotations.fontFamily : null, signatureName: annotations.signatureName ? annotations.signatureName : annotations.Name
        };
        const sessionSize = PdfViewerBase.sessionStorageManager.getWindowSessionStorageSize();
        const currentAnnotation = Math.round(JSON.stringify(annotation).length / 1024);
        if ((sessionSize + currentAnnotation) > 4500) {
            this.pdfViewerBase.isStorageExceed = true;
            this.pdfViewer.annotationModule.clearAnnotationStorage();
            if (!(this.pdfViewerBase.isFormStorageExceed) && this.pdfViewer.formFieldsModule) {
                this.pdfViewer.formFieldsModule.clearFormFieldStorage();
            }
        }
        const storeObject = PdfViewerBase.sessionStorageManager.getItem(this.pdfViewerBase.documentId + '_annotations_sign');
        let index = 0;
        if (!storeObject) {
            this.storeSignatureCollections(annotation, pageNumber);
            const shapeAnnotation = { pageIndex: pageNumber, annotations: [] };
            shapeAnnotation.annotations.push(annotation);
            index = shapeAnnotation.annotations.indexOf(annotation);
            const annotationCollection = [];
            annotationCollection.push(shapeAnnotation);
            const annotationStringified = JSON.stringify(annotationCollection);
            if (this.pdfViewerBase.isStorageExceed) {
                this.pdfViewerBase.annotationStorage[this.pdfViewerBase.documentId + '_annotations_sign'] = annotationStringified;
            }
            else {
                PdfViewerBase.sessionStorageManager.setItem(this.pdfViewerBase.documentId + '_annotations_sign', annotationStringified);
            }
        }
        else {
            this.storeSignatureCollections(annotation, pageNumber);
            const annotObject = JSON.parse(storeObject);
            PdfViewerBase.sessionStorageManager.removeItem(this.pdfViewerBase.documentId + '_annotations_sign');
            const pageIndex = this.pdfViewer.annotationModule.getPageCollection(annotObject, pageNumber);
            if (!isNullOrUndefined(pageIndex) && annotObject[parseInt(pageIndex.toString(), 10)]) {
                annotObject[parseInt(pageIndex.toString(), 10)].annotations.push(annotation);
                index = annotObject[parseInt(pageIndex.toString(), 10)].annotations.indexOf(annotation);
            }
            else {
                const markupAnnotation = { pageIndex: pageNumber, annotations: [] };
                markupAnnotation.annotations.push(annotation);
                index = markupAnnotation.annotations.indexOf(annotation);
                annotObject.push(markupAnnotation);
            }
            const annotationStringified = JSON.stringify(annotObject);
            if (this.pdfViewerBase.isStorageExceed) {
                this.pdfViewerBase.annotationStorage[this.pdfViewerBase.documentId + '_annotations_sign'] = annotationStringified;
            }
            else {
                PdfViewerBase.sessionStorageManager.setItem(this.pdfViewerBase.documentId + '_annotations_sign', annotationStringified);
            }
        }
    }
    /**
     * @param {string} property - It describes about the property value
     * @param {number} pageNumber - It describes about the page number
     * @param {any} annotationBase - It describes about the annotation base
     * @param {boolean} isSignatureEdited - It describes about the whether the isSignatureEdited is true or not
     * @private
     * @returns {ISignAnnotation} - Isignannotation
     */
    modifySignatureCollection(property, pageNumber, annotationBase, isSignatureEdited) {
        this.pdfViewerBase.updateDocumentEditedProperty(true);
        let currentAnnotObject = null;
        const pageAnnotations = this.getAnnotations(pageNumber, null);
        const zoomvalue = this.pdfViewerBase.getZoomFactor();
        if (pageAnnotations != null && annotationBase) {
            for (let i = 0; i < pageAnnotations.length; i++) {
                if (annotationBase.id === pageAnnotations[parseInt(i.toString(), 10)].id) {
                    if (property === 'bounds') {
                        let top;
                        let left;
                        if (annotationBase.shapeAnnotationType === 'SignatureText' && annotationBase.wrapper && annotationBase.wrapper.children[1]) {
                            top = annotationBase.wrapper.children[0].bounds.y;
                            left = annotationBase.wrapper.children[0].bounds.x + annotationBase.wrapper.pivot.x +
                                (this.signatureTextContentLeft - (this.signatureTextContentTop * (zoomvalue -
                                    (zoomvalue / this.signatureTextContentLeft))));
                            top = top + ((annotationBase.wrapper.children[1].bounds.y - top) -
                                (annotationBase.wrapper.children[1].bounds.y - top) / 3) + annotationBase.wrapper.pivot.y +
                                (this.signatureTextContentTop * zoomvalue);
                            pageAnnotations[parseInt(i.toString(), 10)].bounds =
                                { left: left, top: top, width: annotationBase.bounds.width, height: annotationBase.bounds.height };
                        }
                        else {
                            pageAnnotations[parseInt(i.toString(), 10)].bounds =
                                { left: annotationBase.wrapper.bounds.left, top: annotationBase.wrapper.bounds.top,
                                    width: annotationBase.bounds.width, height: annotationBase.bounds.height };
                        }
                        pageAnnotations[parseInt(i.toString(), 10)].fontSize = annotationBase.fontSize;
                    }
                    else if (property === 'stroke') {
                        pageAnnotations[parseInt(i.toString(), 10)].strokeColor = annotationBase.wrapper.children[0].style.strokeColor;
                    }
                    else if (property === 'opacity') {
                        pageAnnotations[parseInt(i.toString(), 10)].opacity = annotationBase.wrapper.children[0].style.opacity;
                    }
                    else if (property === 'thickness') {
                        pageAnnotations[parseInt(i.toString(), 10)].thickness = annotationBase.wrapper.children[0].style.strokeWidth;
                    }
                    else if (property === 'delete') {
                        this.updateSignatureCollection(pageAnnotations[parseInt(i.toString(), 10)]);
                        currentAnnotObject = pageAnnotations.splice(i, 1)[0];
                        break;
                    }
                    if (property && property !== 'delete') {
                        this.storeSignatureCollections(pageAnnotations[parseInt(i.toString(), 10)], pageNumber);
                    }
                    if (isSignatureEdited) {
                        pageAnnotations[parseInt(i.toString(), 10)].opacity = annotationBase.wrapper.children[0].style.opacity;
                        pageAnnotations[parseInt(i.toString(), 10)].strokeColor = annotationBase.wrapper.children[0].style.strokeColor;
                        pageAnnotations[parseInt(i.toString(), 10)].thickness = annotationBase.wrapper.children[0].style.strokeWidth;
                        this.storeSignatureCollections(pageAnnotations[parseInt(i.toString(), 10)], pageNumber);
                        break;
                    }
                }
            }
            this.manageAnnotations(pageAnnotations, pageNumber);
        }
        return currentAnnotObject;
    }
    /**
     * @param {any} annotation - It describes about the annotation
     * @param {number} pageNumber - It describes about the page number
     * @private
     * @returns {void}
     */
    storeSignatureCollections(annotation, pageNumber) {
        const collectionDetails = this.checkSignatureCollection(annotation);
        const selectAnnotation = cloneObject(annotation);
        selectAnnotation.annotationId = annotation.signatureName;
        selectAnnotation.pageNumber = pageNumber;
        delete selectAnnotation.annotName;
        if (annotation.id) {
            selectAnnotation.uniqueKey = annotation.id;
            delete selectAnnotation.id;
        }
        if (collectionDetails.isExisting) {
            this.pdfViewer.signatureCollection.splice(collectionDetails.position, 0, selectAnnotation);
        }
        else {
            this.pdfViewer.signatureCollection.push(selectAnnotation);
        }
    }
    checkSignatureCollection(signature) {
        const collections = this.pdfViewer.signatureCollection;
        if (collections && signature) {
            for (let i = 0; i < collections.length; i++) {
                const signatureName = collections[parseInt(i.toString(), 10)].annotationId ?
                    collections[parseInt(i.toString(), 10)].annotationId : collections[parseInt(i.toString(), 10)].signatureName;
                if (signatureName === signature.signatureName &&
                    (collections[parseInt(i.toString(), 10)].pageNumber === signature.pageNumber ||
                        collections[parseInt(i.toString(), 10)].pageNumber === signature.pageIndex)) {
                    this.pdfViewer.signatureCollection.splice(i, 1);
                    return { isExisting: true, position: i };
                }
            }
        }
        return { isExisting: false, position: null };
    }
    /**
     * @param {any} signature - It describes about the signature
     * @private
     * @returns {void}
     */
    updateSignatureCollection(signature) {
        const collections = this.pdfViewer.signatureCollection;
        if (collections && signature) {
            for (let i = 0; i < collections.length; i++) {
                if (collections[parseInt(i.toString(), 10)].annotationId === signature.signatureName &&
                    (collections[parseInt(i.toString(), 10)].pageNumber === signature.pageNumber ||
                        collections[parseInt(i.toString(), 10)].pageNumber === signature.pageIndex)) {
                    this.pdfViewer.signatureCollection.splice(i, 1);
                    break;
                }
            }
        }
    }
    /**
     * @param {number} pageNumber - It describes about the page number
     * @param {any} signature - It describes about the signature
     * @private
     * @returns {void}
     */
    addInCollection(pageNumber, signature) {
        if (signature) {
            this.storeSignatureCollections(signature, pageNumber);
            const pageSignatures = this.getAnnotations(pageNumber, null);
            if (pageSignatures) {
                pageSignatures.push(signature);
            }
            this.manageAnnotations(pageSignatures, pageNumber);
        }
    }
    /**
     * @param {number} pageIndex - This is current page number
     * @param {any[]}  shapeAnnotations - This is annotations
     * @private
     * @returns {any[]}
     */
    getAnnotations(pageIndex, shapeAnnotations) {
        let annotationCollection;
        let storeObject = null;
        if (this.pdfViewerBase.isStorageExceed) {
            storeObject = this.pdfViewerBase.annotationStorage[this.pdfViewerBase.documentId + '_annotations_sign'];
        }
        else {
            storeObject = PdfViewerBase.sessionStorageManager.getItem(this.pdfViewerBase.documentId + '_annotations_sign');
        }
        if (storeObject) {
            const annotObject = JSON.parse(storeObject);
            const index = this.pdfViewer.annotationModule.getPageCollection(annotObject, pageIndex);
            if (!isNullOrUndefined(index) && annotObject[parseInt(index.toString(), 10)]) {
                annotationCollection = annotObject[parseInt(index.toString(), 10)].annotations;
            }
            else {
                annotationCollection = shapeAnnotations;
            }
        }
        else {
            annotationCollection = shapeAnnotations;
        }
        return annotationCollection;
    }
    /**
     * @param {ISignAnnotation[]} pageAnnotations - This is annotation
     * @param {number}  pageNumber - This is current page number
     * @private
     * @returns {void}
     */
    manageAnnotations(pageAnnotations, pageNumber) {
        let storeObject = null;
        if (this.pdfViewerBase.isStorageExceed) {
            storeObject = this.pdfViewerBase.annotationStorage[this.pdfViewerBase.documentId + '_annotations_sign'];
        }
        else {
            storeObject = PdfViewerBase.sessionStorageManager.getItem(this.pdfViewerBase.documentId + '_annotations_sign');
        }
        if (storeObject) {
            const annotObject = JSON.parse(storeObject);
            PdfViewerBase.sessionStorageManager.removeItem(this.pdfViewerBase.documentId + '_annotations_sign');
            const index = this.pdfViewer.annotationModule.getPageCollection(annotObject, pageNumber);
            if (index != null && annotObject[parseInt(index.toString(), 10)]) {
                annotObject[parseInt(index.toString(), 10)].annotations = pageAnnotations;
            }
            const annotationStringified = JSON.stringify(annotObject);
            if (this.pdfViewerBase.isStorageExceed) {
                this.pdfViewerBase.annotationStorage[this.pdfViewerBase.documentId + '_annotations_sign'] = annotationStringified;
            }
            else {
                PdfViewerBase.sessionStorageManager.setItem(this.pdfViewerBase.documentId + '_annotations_sign', annotationStringified);
            }
        }
    }
    /**
     * @private
     * @param {boolean} isShow - Returns the true or false.
     * @returns {void}
     */
    showSignatureDialog(isShow) {
        if (isShow) {
            this.createSignaturePanel();
        }
    }
    /**
     * @private
     * @returns {void}
     */
    setAnnotationMode() {
        this.pdfViewerBase.isToolbarSignClicked = true;
        this.pdfViewerBase.isInitialField = false;
        this.showSignatureDialog(true);
    }
    /**
     * @private
     * @returns {void}
     */
    setInitialMode() {
        this.pdfViewerBase.isToolbarSignClicked = true;
        this.pdfViewerBase.isInitialField = true;
        this.showSignatureDialog(true);
    }
    /**
     * @param {any} number - Number value
     * @private
     * @returns {number} - number
     */
    ConvertPointToPixel(number) {
        return (number * (96 / 72));
    }
    /**
     * @param {any} signature - It describes about the signature
     * @param {number} pageIndex - It describes about the page index
     * @param {boolean} isImport - It describes about the whether the isImport is true or not
     * @private
     * @returns {PdfAnnotationBaseModel} - PdfAnnotationBaseModel
     */
    updateSignatureCollections(signature, pageIndex, isImport) {
        let annot;
        if (signature) {
            const bounds = signature.Bounds;
            const currentLeft = bounds.X;
            const currentTop = bounds.Y;
            const currentWidth = bounds.Width;
            const currentHeight = bounds.Height;
            let data = signature.PathData;
            if (isImport) {
                data = getPathString(JSON.parse(signature.PathData));
            }
            annot = {
                id: 'sign' + signature.SignatureName, bounds: { x: currentLeft, y: currentTop, width: currentWidth, height: currentHeight }, pageIndex: pageIndex, data: data,
                shapeAnnotationType: 'HandWrittenSignature', opacity: signature.Opacity, strokeColor: signature.StrokeColor, thickness: signature.Thickness, signatureName: signature.SignatureName
            };
            return annot;
        }
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        PdfViewerBase.sessionStorageManager.removeItem('_annotations_sign');
        const signImage = document.getElementById(this.pdfViewer.element.id + '_signElement');
        if (signImage) {
            signImage.removeEventListener('change', this.addStampImage);
            if (signImage.parentElement) {
                signImage.parentElement.removeChild(signImage);
            }
        }
        if (this.signatureDialog) {
            this.signatureDialog.destroy();
        }
        this.mouseDetection = null;
        this.mouseMoving = true;
        this.canvasTouched = false;
        this.signatureImageWidth = null;
        this.signatureImageHeight = null;
        this.oldX = null;
        this.mouseX = null;
        this.oldY = null;
        this.mouseY = null;
        this.imageSignatureDataUrl = '';
        this.drawSignatureDataUrl = '';
        this.newObject = null;
        this.outputString = '';
        this.drawOutputString = '';
        this.imageOutputString = '';
        this.signatureDialog = null;
        this.signaturecollection = [];
        this.outputcollection = [];
        this.signAnnotationIndex = null;
        this.fontName = '';
        this.fontsign = [];
        this.signfontStyle = [];
        this.signtypevalue = '';
        this.signfont = '';
        this.signHeight = '';
        this.signWidth = '';
        this.signaturetype = '';
        this.tabObj = null;
        this.isSaveSignature = false;
        this.isSaveInitial = false;
        this.isInitialFiledSaveSignature = false;
        this.isSignatureFieldsSaveSignature = false;
        this.issaveTypeSignature = false;
        this.issaveImageSignature = false;
        this.issaveTypeInitial = false;
        this.issaveImageInitial = false;
        this.saveSignatureTypeString = '';
        this.saveInitialTypeString = '';
        this.saveTypeString = '';
        this.signatureTypeString = '';
        this.initialTypeString = '';
        this.saveUploadString = '';
        this.saveSignatureUploadString = '';
        this.saveInitialUploadString = '';
        this.signatureUploadString = '';
        this.initialUploadString = '';
        this.clearUploadString = false;
        this.textValue = '';
        this.signatureDrawString = '';
        this.initialDrawString = '';
        this.signatureTextContentTop = 0.2;
        this.signatureTextContentLeft = 0.7;
        this.saveSignatureString = '';
        this.saveInitialString = '';
        this.saveImageString = '';
        this.currentTarget = null;
        this.signatureFieldCollection = [];
        this.signatureImageString = '';
        this.initialImageString = '';
        this.maxSaveLimit = 5;
        this.isAddAnnotationProgramatically = null;
    }
    /**
     * This method was used to add signature programmatically
     *
     * @param {HandWrittenSignatureSettings} annotationObject - It describes type of annotation object
     * @param {IPoint} offset - It describes about the signature bounds or location
     * @param {number} pageNumber - It describes about the signature page number
     * @returns {object} - object
     * @private
     */
    updateSignatureDetails(annotationObject, offset, pageNumber) {
        //Creating new object if annotationObject is null
        if (!annotationObject) {
            annotationObject = { offset: { x: 10, y: 10 }, pageNumber: 0,
                width: undefined, height: undefined };
            offset = annotationObject.offset;
        }
        else if (!annotationObject.offset) {
            offset = { x: 10, y: 10 };
        }
        else {
            offset = annotationObject.offset;
        }
        const signatureId = this.pdfViewer.annotation.createGUID();
        const annotationSettings = this.pdfViewer.annotation.updateSettings(this.pdfViewer.handWrittenSignatureSettings);
        const annotationSelectorSettings = this.pdfViewer.handWrittenSignatureSettings.annotationSelectorSettings;
        this.pdfViewerBase.updateSelectorSettings(annotationSelectorSettings);
        annotationObject.width = annotationObject.width ? annotationObject.width :
            this.pdfViewer.handWrittenSignatureSettings.width ? this.pdfViewer.handWrittenSignatureSettings.width : 150;
        annotationObject.height =
            annotationObject.height ? annotationObject.height : this.pdfViewer.handWrittenSignatureSettings.height ?
                this.pdfViewer.handWrittenSignatureSettings.height : 100;
        annotationObject.thickness =
            annotationObject.thickness ? annotationObject.thickness : this.pdfViewer.handWrittenSignatureSettings.thickness ?
                this.pdfViewer.handWrittenSignatureSettings.thickness : 1;
        annotationObject.opacity =
            annotationObject.opacity ? annotationObject.opacity : this.pdfViewer.handWrittenSignatureSettings.opacity ?
                this.pdfViewer.handWrittenSignatureSettings.opacity : 1;
        annotationObject.strokeColor = annotationObject.strokeColor ? annotationObject.strokeColor : this.pdfViewer.handWrittenSignatureSettings.strokeColor ? this.pdfViewer.handWrittenSignatureSettings.strokeColor : '#000000';
        annotationObject.path = annotationObject.path ? annotationObject.path : this.pdfViewer.handWrittenSignatureSettings.path ? this.pdfViewer.handWrittenSignatureSettings.path : '';
        annotationObject.canSave = annotationObject.canSave ? annotationObject.canSave : false;
        annotationObject.signatureItem = annotationObject.signatureItem ? annotationObject.signatureItem : ['Signature'];
        annotationObject.fontFamily = annotationObject.fontFamily ? annotationObject.fontFamily : 'Helvetica';
        let displayMode;
        let signatureLimit;
        let initialLimit;
        if (annotationObject.signatureItem[0] === 'Initial') {
            displayMode = annotationObject.initialDialogSettings.displayMode ? annotationObject.initialDialogSettings.displayMode : 1;
            initialLimit = annotationObject.saveInitialLimit ? annotationObject.saveInitialLimit :
                this.pdfViewer.handWrittenSignatureSettings.saveInitialLimit;
            this.pdfViewer.handWrittenSignatureSettings.saveInitialLimit =
                this.pdfViewer.handWrittenSignatureSettings.saveInitialLimit < initialLimit ? initialLimit :
                    this.pdfViewer.handWrittenSignatureSettings.saveInitialLimit;
        }
        else {
            displayMode = annotationObject.signatureDialogSettings.displayMode ? annotationObject.signatureDialogSettings.displayMode : 1;
            signatureLimit = annotationObject.saveSignatureLimit ? annotationObject.saveSignatureLimit :
                this.pdfViewer.handWrittenSignatureSettings.saveSignatureLimit;
            this.pdfViewer.handWrittenSignatureSettings.saveSignatureLimit =
                this.pdfViewer.handWrittenSignatureSettings.saveSignatureLimit < signatureLimit ? signatureLimit :
                    this.pdfViewer.handWrittenSignatureSettings.saveSignatureLimit;
        }
        const signatureAnnotation = [];
        let annotType;
        if (displayMode === 1) {
            annotType = 'signature';
            let pathData = annotationObject.path ? annotationObject.path : '';
            if (!isNullOrUndefined(pathData)) {
                // Check whether the given path of the ink annotation is starts with Move path or Line path.
                if (pathData[0] === 'M' || pathData[0] === 'L') {
                    const collectionData = processPathData(pathData);
                    const csData = splitArrayCollection(collectionData);
                    pathData = JSON.stringify(csData);
                }
                else {
                    pathData = getPathString(JSON.parse(pathData));
                }
            }
            annotationObject.path = pathData;
        }
        if (displayMode === 2) {
            annotationObject.height = 65;
            annotType = 'SignatureText';
        }
        if (displayMode === 4) {
            annotType = 'SignatureImage';
        }
        //Adding the annotation object to an array and return it
        const signature = {
            SignatureName: signatureId,
            AnnotationSettings: annotationSettings,
            AnnotationType: annotType,
            AnnotationSelectorSettings: annotationObject.annotationSelectorSettings ?
                annotationObject.annotationSelectorSettings : annotationSelectorSettings,
            Opacity: annotationObject.opacity,
            PathData: annotationObject.path,
            PageNumber: pageNumber,
            FontFamily: annotationObject.fontFamily,
            FontSize: 32,
            StrokeColor: annotationObject.strokeColor,
            Thickness: annotationObject.thickness,
            Bounds: { x: offset.x, y: offset.y, width: annotationObject.width, height: annotationObject.height }
        };
        signatureAnnotation[0] = signature;
        //To save the programmatically added signature
        if (annotationObject.canSave) {
            const bounds = { x: offset.x, y: offset.y, width: annotationObject.width, height: annotationObject.height };
            this.pdfViewerBase.currentSignatureAnnot = null;
            this.outputString = annotationObject.path;
            this.pdfViewerBase.isInitialField = annotationObject.signatureItem[0] === 'Initial' ? true : false;
            let annot;
            if (displayMode === 1) {
                annot = {
                    id: 'sign' + this.pdfViewerBase.signatureCount, bounds: bounds, pageIndex: annotationObject.pageNumber, data: this.outputString,
                    shapeAnnotationType: 'HandWrittenSignature', opacity: annotationObject.opacity, strokeColor: annotationObject.strokeColor, thickness: annotationObject.thickness, signatureName: signatureId
                };
            }
            else if (displayMode === 2) {
                annot = {
                    id: 'sign' + this.pdfViewerBase.signatureCount, bounds: bounds, pageIndex: annotationObject.pageNumber, data: this.outputString, fontFamily: annotationObject.fontFamily, fontSize: 32,
                    shapeAnnotationType: 'SignatureText', signatureName: signatureId
                };
            }
            else if (displayMode === 4) {
                annot = {
                    id: 'sign' + this.pdfViewerBase.signatureCount, bounds: bounds, pageIndex: annotationObject.pageNumber, data: this.outputString,
                    shapeAnnotationType: 'SignatureImage', signatureName: signatureId
                };
            }
            this.pdfViewerBase.currentSignatureAnnot = annot;
            this.addSignatureCollection();
            this.outputString = '';
        }
        return { signatureAnnotation };
    }
}
